<template>
  <div id="expensesValidateComponent">
    <page-title
      :heading="heading"
      :subheading="subheading"
      :icon="icon"
    ></page-title>
    <v-container>
      <v-layout>
        <!-- Dialog view item type=Fiscal && Universal Validate-->
        <v-flex class="text-xs-right">
          <v-dialog v-model="dialogF" scrollable max-width="900px" persistent>
            <v-card v-if="receipt_type === 1">
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">
                  {{ $t('workflowValidation.item') }}{{ editedItem.id }}
                  <span>
                    (
                    {{
                      editedItem.receipt_type
                        ? editedItem.receipt_type.name
                        : ''
                    }}
                    )</span
                  >
                </h2>
                <v-spacer />
                <v-btn v-if="applyFeatures && editedItem.gst_receipt_types_id === 1" round flat color="primary" @click="showEditCategoryF">
                  <v-icon left>list</v-icon> {{ titleTagCategory }}
                </v-btn>
                <v-btn :disabled="!cfdiHtml" round flat color="primary" @click="sendToPrint()">
                  <v-icon left>print</v-icon> {{ $t('general.print') }}
                </v-btn>
                <v-flex class="text-right">
                  <v-btn :disabled="!showPrevious" small icon outline color="primary" @click="viewPrevious(editedItem.id)" class="mx-5">
                    <v-icon small>mdi-arrow-left</v-icon>
                  </v-btn>
                  <v-btn :disabled="!showNext" small icon outline color="primary" @click="viewNext(editedItem.id)" class="mx-5">
                    <v-icon small>mdi-arrow-right</v-icon>
                  </v-btn>
                  <v-btn small icon color="error" @click="close" class="ml-5">
                    <v-icon small>clear</v-icon>
                  </v-btn>
                </v-flex>
              </v-toolbar>
              <v-card-text v-if="!editCategoryF">
                <iframe
                  name="cfdi"
                  :srcdoc="cfdiHtml"
                  style="width: 845px; height: 1200px; border: 0"
                >
                </iframe>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-form lazy-validation ref="formf" v-model="validF">
                      <v-flex xs12 md6>
                        <v-select
                          required
                          :items="categories"
                          item-value="id"
                          item-text="name"
                          class="mr-3"
                          :rules="rules.required"
                          :label="$t('categories.name')"
                          :error-messages="errors.gst_category_id"
                          v-model="editedItem.gst_categories_id"
                        >
                        </v-select>
                      </v-flex>
                    </v-form>
                    <v-flex xs12>
                      <v-textarea
                        :label="$t('general.comment')"
                        disabled
                        outline
                        v-model="editedItem.comment"
                      >
                      </v-textarea>
                    </v-flex>
                    <h2 class="font-weight-black primary--text mb-0 flex xs12">
                      {{ formTitleTip }}
                    </h2>
                    <v-form
                      v-if="editedItemTip.created_at !== ''"
                      ref="tipForm"
                      lazy-validation
                    >
                      <v-container>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-text-field
                              v-model="editedItemTip.amount"
                              :error-messages="errors.amount"
                              :rules="rules.required"
                              :label="$t('general.amount')"
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex v-if="dataURL">
                            <v-flex xs12>
                              <label>{{ $t('expenses.file') }}:</label>
                              <a v-if="!isPDF(dataURL)" @click="openPDF()">
                                <zoom-on-hover
                                  :img-normal="dataURL"
                                ></zoom-on-hover>
                              </a>
                              <v-btn
                                block
                                v-if="isPDF(dataURL)"
                                @click="openPDF()"
                                color="primary"
                                depressed
                              >
                                <v-icon left>insert_drive_file</v-icon>
                                {{ $t('expenseItems.watchFile') }}
                              </v-btn>
                              <iframe
                                v-if="isPDF(dataURL)"
                                :src="dataURL"
                                frameborder="0"
                                width="100%"
                                height="400px"
                              ></iframe>
                            </v-flex>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-form>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-text v-if="editCategoryF">
                <v-layout>
                  <v-flex md12>
                    <h3 class="font-weight-black primary--text mb-0">{{ $t('general.concepts') }}</h3>
                    <v-layout>
                      <v-data-table style="width: 100%;" :headers="conceptsHeader" :items="conceptos" loading-text="Cargando contenido" no-data-text="No hay datos que mostrar" hide-actions >
                          <template v-slot:items="props">
                            <tr>
                                <td class="text-sm-left text-truncate" style="width: 40%">
                                  <v-text-field
                                    auto-grow
                                    outlined
                                    dense
                                    :hide-details="true"
                                    color="primary"
                                    v-model="props.item.line"
                                    :disabled="true"
                                  />
                                  </td>
                                  <td style="width: 20%">
                                  <v-text-field
                                    outlined
                                    dense
                                    :hide-details="true"
                                    color="primary"
                                    v-model="props.item.amount"
                                    :disabled="true"
                                  />
                                  </td>
                                  <td style="width: 30%" class="text-sm-center">
                                    <v-autocomplete class="text-sm-center" :label="$t('general.category')" v-model="props.item.gst_category_id" item-text="name" item-value="id" dense hide-details :disabled="!editItemCategories[props.index]"  :rules="rules.required" :items="categories"  color="primary"/>
                                  </td>
                                  <td style="width: 10%">
                                <v-tooltip right>
                                  <template v-slot:activator="{ on }">
                                    <v-btn :disabled="editItemCategories[props.index]" @click="editConceptsCategory(props.item, props.index)" small icon outline color="primary" v-on="on">
                                      <v-icon small>edit</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>{{ $t('general.edit') }}</span>
                                </v-tooltip>
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="primary darken-1"
                  flat
                  round
                  class="white--text"
                  depressed
                  @click="close"
                >
                  {{ $t('general.close') }}
                </v-btn>
                <v-spacer />
                <div v-if="editedItem.receipt_type">
                  <v-btn
                    color="success darken-1"
                    round
                    flat
                    v-if="editedItem.receipt_type.id == 1"
                    :loading="loadingXML"
                    @click="downloadXML('itemF')"
                  >
                    {{ $t('general.downloadXML') }}
                  </v-btn>
                </div>
                <v-btn
                  color="error"
                  round
                  class="white--text"
                  depressed
                  @click="removedF(editedItem, true)"
                >
                  {{ $t('workflowValidation.rejec') }}
                </v-btn>
                <v-btn
                  color="primary"
                  round
                  depressed
                  :loading="loading"
                  :disabled="loading || editable"
                  @click="saveF(editedItem)"
                >
                  {{ $t('general.save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-card v-else>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">
                  {{ $t('workflowValidation.item') }}{{ editedItem.id }}
                  <span>
                    (
                    {{
                      editedItem.receipt_type
                        ? editedItem.receipt_type.name
                        : ''
                    }}
                    )</span
                  >
                </h2>
                <v-btn class="marginLeft" v-if="editedItem.gst_receipt_types_id === 3 && applyFeatures" round flat color="primary" @click="showEditCategory">
                  <v-icon left>list</v-icon> {{ titleTagCategory }}
                </v-btn>
                <v-flex class="text-right">
                  <v-btn :disabled="!showPrevious" small icon outline color="primary" @click="viewPrevious(editedItem.id)" class="mx-5">
                    <v-icon small>mdi-arrow-left</v-icon>
                  </v-btn>
                  <v-btn :disabled="!showNext" small icon outline color="primary" @click="viewNext(editedItem.id)" class="mx-5">
                    <v-icon small>mdi-arrow-right</v-icon>
                  </v-btn>
                  <v-btn small icon color="error" @click="close" class="ml-5">
                    <v-icon small>clear</v-icon>
                  </v-btn>
                </v-flex>
              </v-toolbar>
              <v-card-text v-if="!editCategory">
                <v-form lazy-validation ref="form" v-model="valid">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex layout row wrap v-bind:class="{ xs6: dataURL }">
                        <v-flex xs12>
                          <v-text-field
                            :label="$t('general.date')"
                            v-model="editedItem.date"
                            disabled
                            prepend-icon="event"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.country')"
                            disabled
                            prepend-icon="location_on"
                            v-model="editedItem.country.descripcion"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 v-if="editedItem.gst_category_id !== null">
                          <v-select
                            required
                            :items="categories"
                            item-value="id"
                            item-text="name"
                            class="mr-3"
                            :rules="rules.required"
                            :label="$t('categories.name')"
                            prepend-icon="list"
                            :error-messages="errors.gst_category_id"
                            v-model="editedItem.gst_category_id"
                          >
                            <template slot="selection" slot-scope="data">
                              {{ data.item.name }}
                            </template>
                            <template slot="item" slot-scope="data">
                              {{ data.item.name }}
                            </template>
                          </v-select>
                        </v-flex>
                        <v-flex v-if="editedItem.projectName"  xs12 md12>
                          <v-text-field v-model="editedItem.projectName" :label="$t('general.project')" prepend-icon="list" disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            :label="$t('general.description')"
                            disabled
                            prepend-icon="forum"
                            v-model="editedItem.description"
                          >
                          </v-textarea>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.currency')"
                            disabled
                            prepend-icon="paid"
                            v-model="editedItem.currency.descripcion"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.exchangeRate')"
                            disabled
                            prepend-icon="currency_exchange"
                            v-model="editedItem.exchange"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 v-if="editedItem.gst_receipt_types_id === 3">
                          <v-text-field
                            :label="$t('general.supplier')"
                            disabled
                            prepend-icon="store"
                            v-model="editedItem.vendor.name">
                          </v-text-field>
                        </v-flex>
                        <!-- <v-flex xs12 md6 v-if="editedItem.gst_receipt_types_id === 3">
                          <v-text-field
                            :label="$t('general.iva')"
                            disabled
                            prepend-icon="percent"
                            v-model="editedItem.foreign_tax.percent"
                          >
                          </v-text-field>
                        </v-flex> -->
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.subtotal')"
                            disabled
                            prepend-icon="attach_money"
                            v-model="editedItem.subtotal"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.total')"
                            disabled
                            prepend-icon="attach_money"
                            v-model="editedItem.total"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex  xs12 md6>
                          <v-text-field v-if="editedItem.sat_forma_pago != null" :label="$t('general.formaPago')" disabled prepend-icon="credit_card" v-model="editedItem.sat_forma_pago.descripcion">
                          </v-text-field>
                          <v-text-field v-else :label="$t('general.formaPago')" disabled prepend-icon="credit_card"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.folioRef')"
                            disabled
                            prepend-icon="article"
                            v-model="editedItem.folio"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            :label="$t('general.comment')"
                            disabled
                            prepend-icon="3p"
                            v-model="editedItem.comment"
                          >
                          </v-textarea>
                        </v-flex>
                      </v-flex>
                      <v-flex xs6 layout v-if="dataURL">
                        <v-flex xs12>
                          <a v-if="!isPDF(dataURL)" @click="openPDF()">
                            <zoom-on-hover
                              :img-normal="dataURL"
                            ></zoom-on-hover>
                          </a>
                          <iframe
                            v-if="isPDF(dataURL)"
                            :src="dataURL"
                            frameborder="0"
                            width="100%"
                            height="400px"
                          ></iframe>
                          <v-btn
                            block
                            v-if="isPDF(dataURL)"
                            @click="openPDF()"
                            color="primary"
                            depressed
                          >
                            <v-icon left>insert_drive_file</v-icon>
                            {{ $t('expenseItems.watchFile') }}
                          </v-btn>
                        </v-flex>
                      </v-flex>
                      <h2
                        class="font-weight-black primary--text mb-0 flex xs12"
                      >
                        {{ formTitleTip }}
                      </h2>
                      <v-form
                        v-if="editedItemTip.created_at !== ''"
                        ref="tipForm"
                        lazy-validation
                      >
                        <v-container>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-text-field
                                v-model="editedItemTip.amount"
                                :error-messages="errors.amount"
                                :rules="rules.required"
                                :label="$t('general.amount')"
                              >
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 layout v-if="dataURL">
                              <v-flex xs12>
                                <label>{{ $t('expenses.file') }}:</label>
                                <a v-if="!isPDF(dataURL)" @click="openPDF()">
                                  <zoom-on-hover
                                    :img-normal="dataURL"
                                  ></zoom-on-hover>
                                </a>
                                <v-btn
                                  block
                                  v-if="isPDF(dataURL)"
                                  @click="openPDF()"
                                  color="primary"
                                  depressed
                                >
                                  <v-icon left>insert_drive_file</v-icon>
                                  {{ $t('expenseItems.watchFile') }}
                                </v-btn>
                                <iframe
                                  v-if="isPDF(dataURL)"
                                  :src="dataURL"
                                  frameborder="0"
                                  width="100%"
                                  height="400px"
                                ></iframe>
                              </v-flex>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-form>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-text v-if="editCategory">
                <v-layout>
                  <v-flex md12>
                    <h3 class="font-weight-black primary--text mb-0">{{ $t('general.concepts') }}</h3>
                    <v-layout>
                      <!-- VALIDAR UNIVERSALES  -->
                        <v-data-table style="width: 100%;" :headers="conceptsHeaderUniversal" :items="concepts"  loading-text="Cargando contenido" :footer-props="{ 'items-per-page-options': [-1] }" hide-default-footer no-data-text="No hay datos que mostrar" disable-pagination hide-actions>
                          <template v-slot:items="props">
                            <tr>
                              <td class="text-sm-left text-truncate" style="width: 40%">
                                <v-textarea class="text-sm-center dynamic-textarea" rows="1"  auto-grow outlined dense :hide-details="true" color="primary" v-model="props.item.line"  type="text" :disabled="true"/>
                              </td>
                              <td style="width: 15%">
                                <span>{{ props.item.amount }}</span>
                              </td>
                              <td style="width: 10%" class="text-sm-center">
                                <span>{{ props.item.line_taxes[0].rate }} %</span>
                              </td>
                              <td style="width: 35%">
                                <v-autocomplete  class="text-sm-center"  v-model="props.item.gst_category_id" item-text="name" item-value="id" dense hide-details :disabled="!editItemCategories[props.index]"  :rules="rules.required" :items="categories"  color="primary" />
                              </td>
                            </tr>
                            <tr style="width: 100%;" class="totals-row" :class="props.index % 2 === 0 ? 'grey-row' : 'white-row'">
                              <td colspan="4" style="padding: 0; height: 10px">
                                <div style="display: flex; justify-content: space-between; align-items: center;">
                                  <div style="flex: 1;"></div>
                                  <div style="flex: 0 0 auto; padding: 0 5px;">
                                    <b> {{ $t('general.total') }} : </b>
                                    <span>{{ (props.item.amount + props.item.line_taxes[0].amount).toFixed(2)}}</span>
                                  </div>
                                  <div style="flex: 0 0 auto; padding: 0 5px;">
                                    <b> {{ $t('general.total') + ' ' + tagMoneda }} : </b>
                                    <span>{{ ((props.item.amount + props.item.line_taxes[0].amount) * editedItem.exchange ).toFixed(2) }}</span>
                                  </div>
                                  <div style="flex: 0 0 auto; text-align: right; padding: 0 5px;">
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-btn :disabled="editItemCategories[props.index]" @click="editConceptsCategory(props.item, props.index)"  icon outline color="primary" v-on="on">
                                          <v-icon small>edit</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>{{ $t('general.edit') }}</span>
                                    </v-tooltip>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" flat round class="white--text" depressed @click="close">
                  {{ $t('general.close') }}
                </v-btn>
                <v-btn color="error" round class="white--text" depressed @click="removed(editedItem, true)">
                  {{ $t('workflowValidation.rejec') }}
                </v-btn>
                <v-btn color="primary" round depressed :loading="loading" :disabled="loading || editable" @click="save(editedItem)">
                  {{ $t('general.save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
        <!-- Dialog File dialogFile -->
        <v-dialog persistent v-model="dialogFile" max-width="900px">
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">{{$t('expenses.attachedFiles')}}</h2>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-xs>
                <v-container v-if="loadItem">
                <v-card flat>
                  <v-card-text class="text-center">
                    <v-progress-circular color="primary" size="50" indeterminate/>
                  </v-card-text>
                </v-card>
              </v-container>
              <v-container v-if="!loadItem">
                <template v-if="!$attrs.item">
                  <v-card flat>
                    <v-card-text>
                      <v-layout wrap>
                        <v-flex xs2>
                          <h3> <span class="primary--text font-weight-black"> {{$t('expenseItems.name')}}: </span> #{{editedItemFile.id}} </h3>
                        </v-flex>
                        <v-flex xs7>
                          <h3><span class="primary--text font-weight-black"> {{$t('general.description')}}: </span> {{editedItemFile.description}}</h3>
                        </v-flex>
                        <v-flex xs3>
                          <h3><span class="primary--text font-weight-black"> {{$t('general.category')}}: </span> {{editedItemFile.gst_categories ? editedItemFile.gst_categories.name : ''}}</h3>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                  <v-layout>
                    <v-divider/>
                  </v-layout>
                </template>
                <v-layout wrap>
                  <v-flex xs12>
                    <h3 class="primary--text font-weight-black">{{$t('expenses.files')}}:</h3>
                  </v-flex>
                  <v-flex v-if="editedItemFile.file_attach.length > 0">
                    <v-btn v-for="file in editedItemFile.file_attach" :key="file.id" color="primary" dark @click="watchFile(file)">
                      <v-icon left v-if="file.files_type_id === 9 || file.files_type_id === 12">fas fa-file-archive</v-icon>
                      <v-icon left v-else-if="file.files_type_id === 3">description</v-icon>
                      <v-icon left v-else>insert_photo</v-icon>
                      <h3 class="pb-0 mb-0">{{$t('expenses.file')}} {{file.id}}</h3>
                    </v-btn>
                  </v-flex>
                  <v-flex v-else>
                    <v-alert color="info" outline :value="true" icon="info"> {{$t('expenses.noFiles')}} </v-alert>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-dialog persistent v-model="dialogViewFile" scrollable max-width="900px">
                <v-card>
                  <v-toolbar flat>
                    <h2 class="font-weight-black primary--text mb-0">{{$t('expenses.file') + ': ' + watchItem.id}}</h2>
                  </v-toolbar>
                  <v-card-text class="text-center">
                    <h2 class="text-sm-left primary--text">{{$t('expenses.fileType') + ': ' + fileWatchType}}</h2>
                    <iframe v-if="watchItem.files_type_id === 3 && dataURLFile" :src="dataURL" frameborder="0" width="100%" height="400px" />
                    <zoom-on-hover v-if="dataURLFile && watchItem.files_type_id !== 3" :img-normal="dataURLFile"/>
                    <v-btn color="primary" @click="downloadFile()" :loading="loadBtn" :disabled="loadBtn" v-if="(watchItem.files_type_id === 9 || watchItem.files_type_id === 12) && !loadFile">volver a descargar</v-btn>
                    <v-progress-circular v-if="!dataURLFile && loadFile" color="primary" size="50" indeterminate />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error darken-1" round flat @click="closeViewFile"> {{ $t('general.cancel') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" round flat @click="closeDialogFiles"> {{ $t('general.close') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Dialog confirm delete -->
        <v-flex class="text-xs-right">
          <v-dialog v-model="removeDialog" max-width="500px" persistent>
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black error--text mb-0">
                  {{ $t('workflowValidation.confirmR') }}
                </h2>
              </v-toolbar>
              <v-card-text>
                <v-form lazy-validation ref="formR" v-model="valid2">
                  <v-container grid-list-xs>
                    <v-flex md12 xs12>
                      <h3>
                        {{ $t('workflowValidation.rechazE') }}
                        {{ removedItem.id }}
                      </h3>
                      <p class="mt-4">
                        {{ $t('workflowValidation.descriptionE') }}.
                      </p>
                    </v-flex>
                    <v-flex xs12 md12>
                      <v-textarea
                        v-model="editedItem.validator_comment"
                        :label="$t('general.description')"
                        :rules="rules.required"
                        outline
                      >
                      </v-textarea>
                    </v-flex>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error darken-1" round flat @click="closeDelete">
                  {{ $t('general.cancel') }}
                </v-btn>
                <v-btn
                  color="error"
                  round
                  class="white--text"
                  depressed
                  :loading="loading"
                  :disabled="loading"
                  @click="deleteItem(editedItem)"
                >
                  {{ $t('workflowValidation.rejec') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
        <!-- Dialor confirm delete type=Fiscal Validate-->
        <v-flex class="text-xs-right">
          <v-dialog v-model="removeDialogF" max-width="500px" persistent>
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black error--text mb-0">
                  {{ $t('workflowValidation.confirmR') }}
                </h2>
              </v-toolbar>
              <v-card-text>
                <v-form lazy-validation ref="formDVF" v-model="valid2">
                  <v-container grid-list-xs>
                    <v-flex md12 xs12>
                      <h3>
                        {{ $t('workflowValidation.rechazE') }}
                        {{ removedItemF.id }}
                      </h3>
                      <p class="mt-4">
                        {{ $t('workflowValidation.descriptionE') }}.
                      </p>
                    </v-flex>
                    <v-flex xs12 md12>
                      <v-textarea
                        v-model="editedItem.validator_comment"
                        :label="$t('general.description')"
                        :rules="rules.required"
                        outline
                      >
                      </v-textarea>
                    </v-flex>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="error darken-1"
                  round
                  flat
                  @click="closeDeleteValidateF"
                >
                  {{ $t('general.cancel') }}
                </v-btn>
                <v-btn
                  color="error"
                  round
                  class="white--text"
                  depressed
                  :loading="loading"
                  :disabled="loading"
                  @click="deteleItemValidateF(editedItem)"
                >
                  {{ $t('workflowValidation.rejec') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
        <!-- Dialog confirm validate expenses -->
        <v-flex class="text-xs-right">
          <v-dialog v-model="dialogValidate" max-width="500px" persistent>
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">
                  {{ $t('workflowValidation.confirmValid') }}
                </h2>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-xs>
                  <h3>
                    <p>
                      {{ $t('workflowValidation.validE') }}
                      <span class="font-weight-black primary--text">{{
                        validat.id
                      }}</span
                      >?.
                    </p>
                    <p class="font-weight-black">
                      <span class="primary--text"
                        >{{ $t('general.user') }}:</span
                      >
                      {{ validat.user.name }}.
                    </p>
                  </h3>
                  <v-textarea
                    :label="$t('workflowValidation.addOptionalComment')"
                    v-model="validat.optionalComment"
                  >
                  </v-textarea>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" round flat @click="close">
                  {{ $t('general.cancel') }}
                </v-btn>
                <v-btn
                  color="primary"
                  round
                  class="white--text"
                  depressed
                  :loading="loading"
                  :disabled="loading"
                  @click="validates(validat)"
                >
                  {{ $t('workflowValidation.valid') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
        <!-- Dialog item type = noFiscal Approbed expenses -->
        <v-flex class="text-xs-right">
          <v-dialog
            v-model="dialogApprobedView"
            scrollable
            max-width="800px"
            persistent
          >
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">
                  {{ $t('workflowValidation.item') }}{{ itemsApprobedView.id }}
                  <span>
                    (
                    {{
                      itemsApprobedView.gst_receipt_types
                        ? itemsApprobedView.gst_receipt_types.name
                        : ''
                    }}
                    )</span
                  >
                </h2>
              </v-toolbar>
              <v-card-text>
                <v-form
                  lazy-validation
                  ref="approvedNoFiscalForm"
                  v-model="approvedNoFiscalValid"
                >
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex layout row wrap v-bind:class="{ xs6: dataURL }">
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.date')"
                            disabled
                            outline
                            v-model="itemsApprobedView.date"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-select
                            required
                            :items="categories"
                            item-value="id"
                            item-text="name"
                            class="mr-3"
                            :rules="rules.required"
                            :label="$t('categories.name')"
                            :error-messages="errors.gst_category_id"
                            v-model="itemsApprobedView.gst_categories_id"
                          >
                            <template slot="selection" slot-scope="data">
                              {{ data.item.name }}
                            </template>
                            <template slot="item" slot-scope="data">
                              {{ data.item.name }}
                            </template>
                          </v-select>
                        </v-flex>
                        <!-- REVISAR -->
                        <!-- <v-flex  xs12 md12>
                          <v-text-field v-model="itemsApprobedView.projectName" :label="$t('general.project')" prepend-icon="list" disabled></v-text-field>
                           {{itemsApprobedView}}
                        </v-flex> -->
                        <v-flex xs12 md6 v-if="itemsApprobedView.country_sat">
                          <v-text-field
                            :label="$t('general.country')"
                            disabled
                            outline
                            v-model="itemsApprobedView.country_sat.descripcion"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            :label="$t('general.description')"
                            disabled
                            outline
                            v-model="itemsApprobedView.description"
                          >
                          </v-textarea>
                        </v-flex>
                        <v-flex xs12 md6 v-if="itemsApprobedView.currency_sat">
                          <v-text-field
                            :label="$t('general.currency')"
                            disabled
                            outline
                            v-model="itemsApprobedView.currency_sat.descripcion"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.exchangeRate')"
                            disabled
                            outline
                            v-model="itemsApprobedView.exchange"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.subtotal')"
                            disabled
                            outline
                            v-model="itemsApprobedView.subtotal"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.total')"
                            disabled
                            outline
                            v-model="itemsApprobedView.total"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.formaPago')"
                            disabled
                            outline
                            v-model="
                              itemsApprobedView.sat_forma_pago.descripcion
                            "
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.folioRef')"
                            disabled
                            outline
                            v-model="itemsApprobedView.folio"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            :label="$t('general.comment')"
                            disabled
                            outline
                            v-model="itemsApprobedView.comment"
                          >
                          </v-textarea>
                        </v-flex>
                      </v-flex>
                      <v-flex xs6 layout v-if="dataURL">
                        <v-flex xs12>
                          <a v-if="!isPDF(dataURL)" @click="openPDF()">
                            <zoom-on-hover
                              :img-normal="dataURL"
                            ></zoom-on-hover>
                          </a>
                          <v-btn
                            block
                            v-if="isPDF(dataURL)"
                            @click="openPDF()"
                            color="primary"
                            depressed
                          >
                            <v-icon left>insert_drive_file</v-icon>
                            {{ $t('expenseItems.watchFile') }}
                          </v-btn>
                        </v-flex>
                      </v-flex>
                      <h2
                        class="font-weight-black primary--text mb-0 flex xs12"
                      >
                        {{ formTitleTip }}
                      </h2>
                      <v-form
                        v-if="editedItemTip.created_at !== ''"
                        ref="tipForm"
                        lazy-validation
                      >
                        <v-container>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-text-field
                                v-model="editedItemTip.amount"
                                :error-messages="errors.amount"
                                :rules="rules.required"
                                :label="$t('general.amount')"
                              >
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 layout v-if="dataURL">
                              <v-flex xs12>
                                <label>{{ $t('expenses.file') }}:</label>
                                <a v-if="!isPDF(dataURL)" @click="openPDF()">
                                  <zoom-on-hover
                                    :img-normal="dataURL"
                                  ></zoom-on-hover>
                                </a>
                                <v-btn
                                  block
                                  v-if="isPDF(dataURL)"
                                  @click="openPDF()"
                                  color="primary"
                                  depressed
                                >
                                  <v-icon left>insert_drive_file</v-icon>
                                  {{ $t('expenseItems.watchFile') }}
                                </v-btn>
                                <iframe
                                  v-if="isPDF(dataURL)"
                                  :src="dataURL"
                                  frameborder="0"
                                  width="100%"
                                  height="400px"
                                ></iframe>
                              </v-flex>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-form>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="primary darken-1"
                  flat
                  round
                  class="white--text"
                  depressed
                  @click="close"
                >
                  {{ $t('general.close') }}
                </v-btn>
                <v-spacer />
                <v-btn
                  color="error"
                  round
                  class="white--text"
                  depressed
                  @click="removedApprobed(itemsApprobedView, true)"
                >
                  {{ $t('workflowValidation.rejec') }}
                </v-btn>
                <v-btn
                  color="primary"
                  round
                  depressed
                  :loading="loading"
                  :disabled="loading || editable"
                  @click="saveApprob"
                >
                  {{ $t('general.saveChanges') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
        <!-- Dialog view item type=Fiscal Approbed expenses-->
        <v-flex class="text-xs-right">
          <v-dialog v-model="dialogApprobedF" scrollable max-width="900px" persistent>
            <v-card v-if="receipt_type === 1">
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">
                  {{ $t('workflowValidation.item')
                  }}{{ editedItemApprobedF.id }}
                  <span>
                    (
                    {{
                      editedItemApprobedF.gst_receipt_types
                        ? editedItemApprobedF.gst_receipt_types.name
                        : ''
                    }}
                    )</span
                  >
                </h2>
                <v-spacer />
                <v-btn v-if="editedItemApprobedF.gst_receipt_types_id === 1 && applyFeatures" round flat color="primary" @click="showEditCategoryApprF">
                  <v-icon left>list</v-icon> {{ titleTagCategory }}
                </v-btn>
                <v-btn
                  :disabled="!cfdiHtml"
                  round
                  flat
                  color="primary"
                  @click="sendToPrint()"
                >
                  <v-icon left>print</v-icon> {{ $t('general.print') }}
                </v-btn>
                <v-flex class="text-right">
                  <v-btn
                    :disabled="!showPrevious"
                    small
                    icon
                    outline
                    color="primary"
                    @click="viewPreviousApp(editedItemApprobedF.id)"
                    class="mx-5"
                  >
                    <v-icon small>mdi-arrow-left</v-icon>
                  </v-btn>
                  <v-btn
                    :disabled="!showNext"
                    small
                    icon
                    outline
                    color="primary"
                    @click="viewNextApp(editedItemApprobedF.id)"
                    class="mx-5"
                  >
                    <v-icon small>mdi-arrow-right</v-icon>
                  </v-btn>
                  <v-btn small icon color="error" @click="close" class="ml-5">
                    <v-icon small>clear</v-icon>
                  </v-btn>
                </v-flex>
              </v-toolbar>
              <v-card-text v-if="!editCategoryAppF">
                <iframe
                  name="cfdi"
                  :srcdoc="cfdiHtml"
                  style="width: 845px; height: 1100px; border: 0"
                >
                </iframe>
                <v-form
                  lazy-validation
                  ref="approvedFiscalForm"
                  v-model="approvedFiscalValid"
                >
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 md6>
                        <v-select
                          required
                          :items="categories"
                          item-value="id"
                          item-text="name"
                          class="mr-3"
                          :rules="rules.required"
                          :label="$t('categories.name')"
                          :error-messages="errors.gst_category_id"
                          v-model="editedItemApprobedF.gst_categories_id"
                        >
                          <template slot="selection" slot-scope="data">
                            {{ data.item.name }}
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ data.item.name }}
                          </template>
                        </v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          :label="$t('general.comment')"
                          disabled
                          outline
                          v-model="editedItemApprobedF.comment"
                        >
                        </v-textarea>
                      </v-flex>
                      <h2
                        class="font-weight-black primary--text mb-0 flex xs12"
                      >
                        {{ formTitleTip }}
                      </h2>
                      <v-form
                        v-if="editedItemTip.created_at !== ''"
                        ref="tipForm"
                        lazy-validation
                      >
                        <v-container>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-text-field
                                v-model="editedItemTip.amount"
                                :error-messages="errors.amount"
                                :rules="rules.required"
                                :label="$t('general.amount')"
                              >
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 layout v-if="dataURL">
                              <v-flex xs12>
                                <label>{{ $t('expenses.file') }}:</label>
                                <a v-if="!isPDF(dataURL)" @click="openPDF()">
                                  <zoom-on-hover
                                    :img-normal="dataURL"
                                  ></zoom-on-hover>
                                </a>
                                <v-btn
                                  block
                                  v-if="isPDF(dataURL)"
                                  @click="openPDF()"
                                  color="primary"
                                  depressed
                                >
                                  <v-icon left>insert_drive_file</v-icon>
                                  {{ $t('expenseItems.watchFile') }}
                                </v-btn>
                                <iframe
                                  v-if="isPDF(dataURL)"
                                  :src="dataURL"
                                  frameborder="0"
                                  width="100%"
                                  height="400px"
                                ></iframe>
                              </v-flex>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-form>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-text v-if="editCategoryAppF">
                <v-layout>
                  <v-flex md12>
                    <h3 class="font-weight-black primary--text mb-0">{{ $t('general.concepts') }}</h3>
                    <v-layout>
                      <v-data-table
                          style="width: 100%;"
                          :headers="conceptsHeaderAppF"
                          :items="conceptos"
                          loading-text="Cargando contenido"
                          no-data-text="No hay datos que mostrar"
                          hide-actions
                        >
                        <template v-slot:items="props">
                            <tr>
                                <td class="text-sm-left text-truncate" style="width: 40%">
                                  <v-text-field
                                    auto-grow
                                    outlined
                                    dense
                                    :hide-details="true"
                                    color="primary"
                                    v-model="props.item.line"
                                    :disabled="true"
                                  />
                                  </td>
                                  <td style="width: 20%">
                                  <v-text-field
                                    outlined
                                    dense
                                    :hide-details="true"
                                    color="primary"
                                    v-model="props.item.amount"
                                    :disabled="true"
                                  />
                                  </td>
                                  <td style="width: 30%" class="text-sm-center">
                                    <v-autocomplete class="text-sm-center" :label="$t('general.category')" v-model="props.item.gst_category_id" item-text="name" item-value="id" dense hide-details :disabled="!editItemCategories[props.index]"  :rules="rules.required" :items="categories"  color="primary"/>
                                  </td>
                                  <td style="width: 10%">
                                <v-tooltip right>
                                  <template v-slot:activator="{ on }">
                                    <v-btn :disabled="editItemCategories[props.index]" @click="editConceptsCategory(props.item, props.index)" small icon outline color="primary" v-on="on">
                                      <v-icon small>edit</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>{{ $t('general.edit') }}</span>
                                </v-tooltip>
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="primary darken-1"
                  flat
                  round
                  class="white--text"
                  depressed
                  @click="close"
                >
                  {{ $t('general.close') }}
                </v-btn>
                <v-spacer />
                <v-btn
                  color="success darken-1"
                  round
                  flat
                  :loading="loadingXML"
                  @click="downloadXML('itemApproved')"
                >
                  {{ $t('general.downloadXML') }}
                </v-btn>
                <v-btn
                  color="error"
                  round
                  class="white--text"
                  depressed
                  @click="removedApprobedF(editedItemApprobedF, true)"
                >
                  {{ $t('workflowValidation.rejec') }}
                </v-btn>
                <v-btn
                  color="primary"
                  round
                  depressed
                  :loading="loading"
                  :disabled="loading || editable"
                  @click="saveApprobF(editedItemApprobedF)"
                >
                  {{ $t('general.saveChanges') }}
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-card v-else>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">
                  {{ $t('workflowValidation.item') }}{{ itemsApprobedView.id }}
                  <span>
                    (
                    {{
                      itemsApprobedView.gst_receipt_types
                        ? itemsApprobedView.gst_receipt_types.name
                        : ''
                    }}
                    ){{ itemsApprobedView.isFiscal }}</span
                  >
                </h2>
                <v-btn class="marginLeft" v-if="itemsApprobedView.gst_receipt_types_id === 3 && applyFeatures" round flat color="primary" @click="showEditCategoryApprobed">
                  <v-icon left>list</v-icon> {{ titleTagCategory }}
                </v-btn>
                <v-flex class="text-right">
                  <v-btn
                    :disabled="!showPrevious"
                    small
                    icon
                    outline
                    color="primary"
                    @click="viewPreviousApp(itemsApprobedView.id)"
                    class="mx-5"
                  >
                    <v-icon small>mdi-arrow-left</v-icon>
                  </v-btn>
                  <v-btn
                    :disabled="!showNext"
                    small
                    icon
                    outline
                    color="primary"
                    @click="viewNextApp(itemsApprobedView.id)"
                    class="mx-5"
                  >
                    <v-icon small>mdi-arrow-right</v-icon>
                  </v-btn>
                  <v-btn small icon color="error" @click="close" class="ml-5">
                    <v-icon small>clear</v-icon>
                  </v-btn>
                </v-flex>
              </v-toolbar>
              <v-card-text v-if="!editCategory">
                <v-form
                  lazy-validation
                  ref="approvedNoFiscalForm"
                  v-model="approvedNoFiscalValid"
                >
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex layout row wrap v-bind:class="{ xs6: dataURL }">
                        <v-flex xs12>
                          <v-text-field
                            :label="$t('general.date')"
                            disabled
                            v-model="itemsApprobedView.date"
                            prepend-icon="event"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 v-if="itemsApprobedView.country_sat">
                          <v-text-field
                            :label="$t('general.country')"
                            disabled
                            v-model="itemsApprobedView.country_sat.descripcion"
                            prepend-icon="location_on"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-select
                            required
                            :items="categories"
                            item-value="id"
                            item-text="name"
                            class="mr-3"
                            :rules="rules.required"
                            :label="$t('categories.name')"
                            :error-messages="errors.gst_category_id"
                            v-model="itemsApprobedView.gst_categories_id"
                            prepend-icon="list"
                          >
                            <template slot="selection" slot-scope="data">
                              {{ data.item.name }}
                            </template>
                            <template slot="item" slot-scope="data">
                              {{ data.item.name }}
                            </template>
                          </v-select>
                        </v-flex>
                        <v-flex v-if="itemsApprobedView.has_multiprojects && itemsApprobedView.project_id" xs12 md12>
                          <v-text-field v-model="itemsApprobedView.projectName" :label="$t('general.project')" prepend-icon="list" disabled>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            :label="$t('general.description')"
                            disabled
                            v-model="itemsApprobedView.description"
                            prepend-icon="forum"
                          >
                          </v-textarea>
                        </v-flex>
                        <v-flex xs12 md6 v-if="itemsApprobedView.currency_sat">
                          <v-text-field
                            :label="$t('general.currency')"
                            disabled
                            v-model="itemsApprobedView.currency_sat.descripcion"
                            prepend-icon="paid"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.exchangeRate')"
                            disabled
                            v-model="itemsApprobedView.exchange"
                            prepend-icon="currency_exchange"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 v-if="itemsApprobedView.gst_receipt_types_id === 3">
                          <v-text-field
                            :label="$t('general.supplier')"
                            disabled
                            prepend-icon="store"
                            v-model="itemsApprobedView.vendor.name">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.subtotal')"
                            disabled
                            v-model="itemsApprobedView.subtotal"
                            prepend-icon="attach_money"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.total')"
                            disabled
                            v-model="itemsApprobedView.total"
                            prepend-icon="attach_money"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.formaPago')"
                            disabled
                            v-model="
                              itemsApprobedView.sat_forma_pago.descripcion
                            "
                            prepend-icon="credit_card"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            :label="$t('general.folioRef')"
                            disabled
                            v-model="itemsApprobedView.folio"
                            prepend-icon="article"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            :label="$t('general.comment')"
                            disabled
                            v-model="itemsApprobedView.comment"
                            prepend-icon="3p"
                          >
                          </v-textarea>
                        </v-flex>
                      </v-flex>
                      <v-flex xs6 layout v-if="dataURL">
                        <v-flex xs12>
                          <a v-if="!isPDF(dataURL)" @click="openPDF()">
                            <zoom-on-hover
                              :img-normal="dataURL"
                            ></zoom-on-hover>
                          </a>
                          <iframe
                            v-if="isPDF(dataURL)"
                            :src="dataURL"
                            frameborder="0"
                            width="100%"
                            height="400px"
                          ></iframe>
                          <v-btn
                            block
                            v-if="isPDF(dataURL)"
                            @click="openPDF()"
                            color="primary"
                            depressed
                          >
                            <v-icon left>insert_drive_file</v-icon>
                            {{ $t('expenseItems.watchFile') }}
                          </v-btn>
                        </v-flex>
                      </v-flex>
                      <h2
                        class="font-weight-black primary--text mb-0 flex xs12"
                      >
                        {{ formTitleTip }}
                      </h2>
                      <v-form
                        v-if="editedItemTip.created_at !== ''"
                        ref="tipForm"
                        lazy-validation
                      >
                        <v-container>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-text-field
                                v-model="editedItemTip.amount"
                                :error-messages="errors.amount"
                                :rules="rules.required"
                                :label="$t('general.amount')"
                              >
                              </v-text-field>
                            </v-flex>
                            <v-flex xs12 layout v-if="dataURL">
                              <v-flex xs12>
                                <label>{{ $t('expenses.file') }}:</label>
                                <a v-if="!isPDF(dataURL)" @click="openPDF()">
                                  <zoom-on-hover
                                    :img-normal="dataURL"
                                  ></zoom-on-hover>
                                </a>
                                <v-btn
                                  block
                                  v-if="isPDF(dataURL)"
                                  @click="openPDF()"
                                  color="primary"
                                  depressed
                                >
                                  <v-icon left>insert_drive_file</v-icon>
                                  {{ $t('expenseItems.watchFile') }} FFF
                                </v-btn>
                                <iframe
                                  v-if="isPDF(dataURL)"
                                  :src="dataURL"
                                  frameborder="0"
                                  width="100%"
                                  height="400px"
                                ></iframe>
                              </v-flex>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-form>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-text v-if="editCategory">
                <v-layout>
                  <v-flex md12>
                    <h3 class="font-weight-black primary--text mb-0">{{ $t('general.concepts') }}</h3>
                    <v-layout>
                        <v-data-table style="width: 100%;" :headers="conceptsHeaderUniversal" :items="concepts"  loading-text="Cargando contenido" :footer-props="{ 'items-per-page-options': [-1] }" hide-default-footer no-data-text="No hay datos que mostrar" disable-pagination hide-actions>
                          <template v-slot:items="props">
                            <tr>
                              <td class="text-sm-left text-truncate" style="width: 40%">
                                <v-textarea class="text-sm-center dynamic-textarea" rows="1"  auto-grow outlined dense :hide-details="true" color="primary" v-model="props.item.line"  type="text" :disabled="true"/>
                              </td>
                              <td style="width: 15%">
                                <span>{{ props.item.amount }}</span>
                              </td>
                              <td style="width: 10%" class="text-sm-center">
                                <span>{{ props.item.line_taxes[0].rate }} %</span>
                              </td>
                              <td style="width: 35%">
                                <v-autocomplete  class="text-sm-center"  v-model="props.item.gst_category_id" item-text="name" item-value="id" dense hide-details :disabled="!editItemCategories[props.index]"  :rules="rules.required" :items="categories"  color="primary" />
                              </td>
                            </tr>
                            <tr style="width: 100%;" class="totals-row" :class="props.index % 2 === 0 ? 'grey-row' : 'white-row'">
                              <td colspan="4" style="padding: 0; height: 10px">
                                <div style="display: flex; justify-content: space-between; align-items: center;">
                                  <div style="flex: 1;"></div>
                                  <div style="flex: 0 0 auto; padding: 0 5px;">
                                    <b> {{ $t('general.total') }} : </b>
                                    <span>{{ (props.item.amount + props.item.line_taxes[0].amount).toFixed(2)}}</span>
                                  </div>
                                  <div style="flex: 0 0 auto; padding: 0 5px;">
                                    <b> {{ $t('general.total') + ' ' + tagMoneda }} : </b>
                                    <!-- {{props.item}} -->
                                    <span>{{ ((props.item.amount + props.item.line_taxes[0].amount) * itemsApprobedView.exchange ).toFixed(2) }}</span>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="primary darken-1"
                  flat
                  round
                  class="white--text"
                  depressed
                  @click="close"
                >
                  {{ $t('general.close') }}
                </v-btn>
                <v-spacer />
                <v-btn
                  color="error"
                  round
                  class="white--text"
                  depressed
                  @click="removedApprobed(itemsApprobedView, true)"
                >
                  {{ $t('workflowValidation.rejec') }}
                </v-btn>
                <v-btn
                  color="primary"
                  round
                  depressed
                  :loading="loading"
                  :disabled="loading || editable"
                  @click="saveApprob(itemsApprobedView)"
                >
                  {{ $t('general.saveChanges') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
        <!-- Dialog confirm approbed expenses -->
        <v-flex class="text-xs-right">
          <v-dialog v-model="dialogApprobed" max-width="500px" persistent>
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">
                  {{ $t('workflowValidation.confirmAp') }}
                </h2>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-xs>
                  <h3>
                    <p>
                      {{ $t('workflowValidation.approbE') }}
                      <span class="font-weight-black primary--text">{{
                        approbed.id
                      }}</span
                      >?.
                    </p>
                    <p class="font-weight-black">
                      <span class="primary--text"
                        >{{ $t('general.user') }}:</span
                      >
                      {{ approbed.user.name }}.
                    </p>
                  </h3>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" round flat @click="close">
                  {{ $t('general.cancel') }}
                </v-btn>
                <v-btn
                  color="primary"
                  round
                  class="white--text"
                  depressed
                  :loading="loading"
                  :disabled="loading"
                  @click="approb(approbed)"
                >
                  {{ $t('workflowValidation.approbad') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
        <!-- Dialog confirm delete item expenses Approbed -->
        <v-flex class="text-xs-right">
          <v-dialog v-model="removeDialogApprobed" max-width="500px" persistent>
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black error--text mb-0">
                  {{ $t('workflowValidation.confirmR') }}
                </h2>
              </v-toolbar>
              <v-card-text>
                <v-form lazy-validation ref="formF" v-model="valid2">
                  <v-container grid-list-xs>
                    <v-flex md12 xs12>
                      <h3>
                        {{ $t('workflowValidation.rechazE') }} {{ general.id }}
                      </h3>
                      <p class="mt-4">
                        {{ $t('workflowValidation.descriptionE') }}.
                      </p>
                    </v-flex>
                    <v-flex xs12 md12>
                      <v-textarea
                        v-model="general.validator_comment"
                        :label="$t('general.description')"
                        :rules="rules.required"
                        outline
                      >
                      </v-textarea>
                    </v-flex>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="error darken-1"
                  round
                  flat
                  @click="closeDeleteApprobed"
                >
                  {{ $t('general.cancel') }}
                </v-btn>
                <v-btn
                  color="error"
                  round
                  class="white--text"
                  depressed
                  :loading="loading"
                  :disabled="loading"
                  @click="deteleItemApprobed(general)"
                >
                  {{ $t('workflowValidation.rejec') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
        <!-- Dialog to confirm rejection of selected expense items -->
        <v-flex class="text-xs-right">
          <v-dialog
            v-model="rejectedSelectedDialog"
            max-width="500px"
            persistent
          >
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black error--text mb-0">
                  {{ $t('workflowValidation.confirmR') }}
                </h2>
              </v-toolbar>
              <v-card-text>
                <v-form lazy-validation ref="formR" v-model="valid2">
                  <v-container grid-list-xs>
                    <v-flex md12 xs12>
                      <h3>
                        {{
                          selected.length > 1
                            ? $t('workflowValidation.rejectedAboutExpense')
                            : $t('workflowValidation.rechazE')
                        }}
                        {{
                          rejectedSelectedId.length > 0
                            ? rejectedSelectedId.toString()
                            : 0
                        }}
                      </h3>
                      <p class="mt-4">
                        {{ $t('workflowValidation.descriptionE') }}.
                      </p>
                    </v-flex>
                    <v-flex xs12 md12>
                      <v-textarea
                        v-model="editedItem.validator_comment"
                        :label="$t('general.description')"
                        :rules="rules.required"
                        outline
                      >
                      </v-textarea>
                    </v-flex>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error darken-1" round flat @click="closeDelete">
                  {{ $t('general.cancel') }}
                </v-btn>
                <v-btn
                  color="error"
                  round
                  class="white--text"
                  depressed
                  :loading="loading"
                  :disabled="loading"
                  @click="submitMultipleRejectedItems()"
                >
                  {{ $t('workflowValidation.rejec') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
      <!-- TABS -->
      <v-card>
        <v-tabs v-model="tab" color="bg-sidebar" left dark >
          <v-tabs-slider></v-tabs-slider>
          <v-tab style="background-color: #FDFEFF; color: #1e3c72 !important; width: 28%;" href="#tab-1" v-if="userloggeds.validator != null || userloggeds.substitute != null" @click="viewValidated()">
            <v-icon style="color: #1e3c72 !important; margin-right: 5px;">mdi-thumb-up</v-icon>
            {{ $t('general.validate') }}
            <b-badge style="margin-left: 5px;" pill variant="danger">{{ totalValidate }}</b-badge>
          </v-tab>
          <v-tab href="#tab-2" v-if="userloggeds.approvers != null" @click="viewApprobed()">
            <v-icon style="margin-right: 5px;">mdi-check-circle</v-icon>
            {{ $t('general.approbe') }}
            <b-badge v-if="totalApprobed > 0" style="margin-left: 5px;" pill variant="danger">{{ totalApprobed }}</b-badge>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <!-- Validar gastos -->
          <v-tab-item :key="1" value="tab-1">
            <v-layout class="mt-1 mb-5" >
              <v-flex lg3>
                <v-toolbar style="background-color: #F7F9FA !important;" color="bg-sidebar"  height="90">
                  <v-flex class="d-flex flex-column">
                    <!-- <h5 class="mt-5"> {{ $t('general.validate') }} <b-badge pill variant="danger">{{ expenses.length }}</b-badge> </h5>-->
                    <v-text-field
                      color=" "
                      v-model="valSearch"
                      :label="$t('general.search')"
                      clearable
                      @keyup.enter="searching"
                      @click:append="searching"
                    >
                    <template v-slot:append>
                    <v-icon @click="searching">mdi-magnify</v-icon>
                    </template>
                    </v-text-field> 
                  </v-flex>
                </v-toolbar>
                <!-- <v-data-table
                  :headers="headersEx"
                  :items="expenses"
                  :loading="loadingItems"
                  :items-per-page="paginationGeneral.rowsPerPage"
                  :total-items="paginationGeneral.totalItems"
                > -->
                <div class="table-container" style="max-height: 500px; overflow-y: auto;">
                  <v-data-table
                    class="elevation-2 mt-2"
                    :headers="headersEx"
                    :items="expenses"
                    :loading="loadingItems"
                    :pagination.sync="pagination"
                    :items-per-page="pagination.rowsPerPage"
                    :total-items="pagination.totalItems"
                    @update:pagination="checkPageChange"
                  >
                    <template v-slot:items="props">
                      <tr
                    @click="selectRow(props.item)"
                    class="rowExpense"
                    :class="{ selectedRow: props.item.isSelected }"
                    :key="props.index"
                  >
                    <td class="py-2">
                      <h3 class=" mt-2 font-weight-black primary--text font-weight-black">
                        # <span class="black--text font-weight-black"> {{ props.item.id }}</span>
                      </h3>
                      <span class="font-weight-black">
                        {{ props.item.user.name }}
                      </span>
                      <br />
                      {{ props.item.description }}
                      <h3 class="mt-2 font-weight-black primary--text font-weight-black">
                        {{ $t('general.type') }}:
                        <span class="font-weight-bold type-color">{{ getTypeText(props.item) }}</span>
                      </h3>
                      <h3 v-if="getType(props.item) === 'refund'" class="mt-2 font-weight-black primary--text font-weight-black">
                        {{ $t('general.amount') }}:
                        <span class="black--text font-weight-black">{{ Math.abs(props.item.repay_back) | formatCurrency }} {{ tagMoneda }}</span>
                      </h3>
                      <h3 v-if="getType(props.item) === 'advance'" class=" mt-2 font-weight-black primary--text font-weight-black">
                        {{ $t('general.amount') }}:
                        <span class="black--text font-weight-black">{{ props.item.advance | formatCurrency }}  {{ tagMoneda }}</span>
                      </h3>
                    </td>
                      </tr>
                    </template>
                    <template v-slot:footer>
                      <td colspan="2" class="text-xs-left">
                        <span
                          class="
                            primary--text
                            text-uppercase
                            font-weight-black
                            h6
                          "
                          >{{ $t('general.totalExpenses') }}:</span
                        >
                        <span
                          class="
                            primary--text
                            text-uppercase
                            font-weight-black
                            h6
                          "
                          >{{ sumaTotal | formatCurrency }}  {{ tagMoneda }}</span
                        >
                      </td>
                    </template>
                  </v-data-table>
                </div>
              </v-flex>
              <v-flex xs9 class="ml-2">
                <v-flex xs12 class="d-flex flex-row" v-if="expenses.length > 0">
                  <v-flex xs7 class="d-flex flex-column">
                    <h3>
                      <span class="font-weight-black primary--text"
                        >{{ $t('conciliation.period') }}:
                      </span>
                      {{ dateFormat(startDate) }} - {{ dateFormat(endDate) }}
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            small
                            outline
                            icon
                            v-on="on"
                            compact
                            color="primary"
                            class="ma-0 justify-content-center align-center align-items-center"
                            @click="editExpenseItem(item)"
                          >
                            <v-icon size="small">mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('expenses.editPeriod') }}</span>
                      </v-tooltip>
                    </h3>
                    <v-flex xs12>
                      <v-layout>
                        <v-flex xs6 class="d-flex mb-1">
                          <h3 class="mt-2">
                            <span class="font-weight-black primary--text"
                              >{{ $t('general.project') }}:</span
                            >
                            {{ item && item.project && item.project.name }}
                          </h3>
                        </v-flex>
                        <v-flex xs6 class="d-flex mb-1">
                          <h3 class="mt-2">
                            <span class="font-weight-black primary--text">
                              {{ $t('workflowValidation.expenseNo') }}:
                            </span>
                            {{ item && item.id ? item.id : '--' }}
                          </h3>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout>
                        <v-flex xs12>
                          <h3 class="mt-2 font-weight-black primary--text font-weight-black">
                            {{ $t('expenses.type') }}:
                            <span class="font-weight-bold type-color">{{ typeText }}</span>
                          </h3>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex class="d-flex flex-column">
                      <v-layout>
                        <v-flex xs12>
                          <h3 v-if="type === 'refund'" class="mt-2 font-weight-black primary--text font-weight-black">
                            {{ $t('expenses.amountOf') }} {{ $t('general.refund') }}:
                            <span class="black--text font-weight-black">{{ Math.abs(repay_back) | formatCurrency }} {{ tagMoneda }}</span>
                          </h3>
                          <h3 v-if="type === 'advance'" class="mt-2 font-weight-black primary--text font-weight-black">
                            {{ $t('expenses.amountOf') }} {{ $t('general.advance') }}:
                            <span class="black--text font-weight-black">{{ advance | formatCurrency }}  {{ tagMoneda }}</span>
                          </h3>
                          <h3 v-if="type === 'petty_cash'" class=" mt-2 font-weight-black primary--text font-weight-black">
                            {{ $t('general.amount') }}:
                            <span class="black--text font-weight-black">{{ Math.abs(repay_back) | formatCurrency }} {{ tagMoneda }}</span>
                          </h3>
                        </v-flex>
                      </v-layout>
                      <!-- Propina -->
                      <v-layout v-if="totalTip > 0">
                        <v-flex>
                          <h3
                            class="
                              mt-2
                              font-weight-black
                              primary--text
                              font-weight-black
                            "
                          >
                            Total + propina:
                            <span class="black--text font-weight-black">{{
                              new Intl.NumberFormat('es-MX', {
                                style: 'currency',
                                currency: 'MXN',
                              }).format(totalGlobal + totalTip)
                            }}</span>
                          </h3>
                        </v-flex>
                        <v-flex xs4>
                          <h3
                            class="
                              mt-2
                              font-weight-black
                              primary--text
                              font-weight-black
                            "
                          >
                            Propina:
                            <span class="font-weight-bold black--text"
                              >{{
                                new Intl.NumberFormat('es-MX', {
                                  style: 'currency',
                                  currency: 'MXN',
                                }).format(totalTip)
                              }}
                            </span>
                          </h3>
                        </v-flex>
                      </v-layout>

                      <v-layout v-if="type === 'advance'" class="d-flex flex-row">
                        <v-flex>
                          <h3
                            v-if="isRefund(repay_back) === 'refund'"
                            style="color: tomato"
                            class="mt-2 font-weight-black"
                          >
                            {{ $t('general.refund') }}
                            {{ Math.abs(repay_back) | formatCurrency }}  {{ tagMoneda }}
                          </h3>
                          <h3
                            v-if="isRefund(repay_back) === 'payment'"
                            style="color: #00ab66"
                            class="mt-2 font-weight-black"
                          >
                            {{ $t('general.payment') }}
                            {{ Math.abs(repay_back) | formatCurrency }}  {{ tagMoneda }}
                          </h3>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout class="d-flex flex-row">
                      <v-flex xs6 class="d-flex mb-1">
                        <v-btn
                          v-if="selected.length > 0"
                          color="error"
                          round
                          small
                          depressed
                          @click="selectedExpenseItems()"
                        >
                          {{ $t('workflowValidation.rejec') }}
                        </v-btn>
                      </v-flex>
                      <v-flex xs6 class="d-flex mb-1">
                        <v-btn
                          :disabled="validateBtn || selected.length > 0"
                          color="primary"
                          round
                          small
                          depressed
                          @click="confirmValidate(item)"
                        >
                          {{ $t('workflowValidation.valid') }}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout class="d-flex flex-row">
                      <v-flex xs6 class="d-flex mb-1"> </v-flex>
                      <v-flex xs6 class="d-flex mb-1">
                        <div class="text-center">
                          <v-tooltip
                            top
                            v-if="
                              expensesProgress && expensesProgress.length > 0
                            "
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn
                                icon
                                outline
                                large
                                color="primary"
                                v-on="on"
                                @click="openValidatorComment"
                              >
                                <v-icon>mdi-message-alert</v-icon>
                              </v-btn>
                            </template>
                            <span>{{
                              $t('workflowValidation.validatorComments')
                            }}</span>
                          </v-tooltip>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout class="d-flex flex-row">
                      <v-flex xs6 class="d-flex mb-1"> </v-flex>
                      <v-flex xs6 class="d-flex mb-1">
                        <div class="text-center">
                          <v-tooltip
                            top
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn
                                icon
                                outline
                                large
                                color="primary"
                                v-on="on"
                                @click="openBackCheckoutDialog(item)"
                              >
                                <v-icon>mdi-backup-restore</v-icon>
                              </v-btn>
                            </template>
                            <span>{{
                              $t('expenses.backCheckout')
                            }}</span>
                          </v-tooltip>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-flex>
                <div class="table-container" style="max-height: 400px; overflow-y: auto;">
                  <v-data-table
                    v-model="selected"
                    no-data-text="No hay datos que mostrar"
                    :headers="headersItems"
                    :items="expensesItems.length > 0 ? expensesItems : []"
                    :loading="loadingItems"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationItems"
                  >
                    <template v-slot:headers="props">
                      <tr class="bg-heavy-rain">
                        <th>
                          <v-checkbox
                            class="justify-center align-center"
                            :input-value="props.all"
                            :indeterminate="props.indeterminate"
                            color="primary"
                            hide-details
                            @click.stop="toggleAll('Validate')"
                          ></v-checkbox>
                        </th>
                        <th v-for="header in props.headers" :key="header.text" :class="[ 'column', header.sortable ? 'sortable' : '', paginationItems.descending ? 'desc' : 'asc', header.value === paginationItems.sortBy ? 'active' : '', ]">
                        <!-- @click="changeSortItems(header.value)" -->
                          <h3 class="font-weight-black primary--text mb-0">
                            <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                            {{ header.text }}
                          </h3>
                        </th>
                      </tr>
                    </template>
                    <template v-slot:items="props">
                      <tr v-if="props.item.has_multiprojects && props.item.isTitle && props.item.project_id" style="background-color: lightblue">
                        <td colspan="9"><b>{{ $t('general.project') }} : {{ props.item.projectName }}</b></td>
                      </tr>
                      <tr>
                        <td  colspan="2" style="padding: 3px;" :class="{'custom-row-color': props.item.gst_receipt_types_id === 4, 'warning-rows': props.item.warning_restriction}">
                          <div style="display: flex; align-items: center;">
                            <v-checkbox :input-value="props.selected" :disabled="props.item.gst_receipt_types_id === 4" color="primary" hide-details v-model="props.selected" style="margin-right: 1px;"></v-checkbox>
                            <span style="margin-left: -10px; margin-right: -3px;">
                              {{ props.item.id }}
                            </span>
                            <!-- <div
                              class="text-center"
                              v-if="props.item.warning_restriction"
                              style="margin-left: 5px;"
                            >
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <v-icon
                                    style="vertical-align: middle"
                                    v-if="props.item.warning_restriction"
                                    class="warning--text"
                                    size="18"
                                    v-on="on"
                                  >mdi-alert-octagram</v-icon>
                                </template>
                                {{ props.item.warning_restriction }}
                              </v-tooltip>
                            </div> -->
                          </div>
                        </td>
                        <td :class="{'custom-row-color': props.item.gst_receipt_types_id === 4, 'warning-rows': props.item.warning_restriction}">{{ props.item.description }}</td>
                        <td :class="{'custom-row-color': props.item.gst_receipt_types_id === 4, 'warning-rows': props.item.warning_restriction}">
                          {{ props.item.gst_categories ? props.item.gst_categories.name : '' }}
                        </td>
                        <td :class="{'custom-row-color': props.item.gst_receipt_types_id === 4, 'warning-rows': props.item.warning_restriction}">{{ props.item.total | formatCurrency }}</td>
                        <td :class="{'custom-row-color': props.item.gst_receipt_types_id === 4, 'warning-rows': props.item.warning_restriction}">{{ parseFloat(props.item.exchange).toFixed(2) }}</td>
                        <td :class="{'custom-row-color': props.item.gst_receipt_types_id === 4, 'warning-rows': props.item.warning_restriction}">{{ props.item.total_mxn | formatCurrency }}</td>
                        <td :class="{'custom-row-color': props.item.gst_receipt_types_id === 4, 'warning-rows': props.item.warning_restriction}">{{ props.item.currency && props.item.currency.c_Moneda }}</td>
                        <td style="width: 14%; padding: 0 10px" :class="{'custom-row-color': props.item.gst_receipt_types_id === 4, 'warning-rows': props.item.warning_restriction}">
                        <v-layout v-if="props.item.gst_receipt_types_id !== 4" row class="d-inline-flex">
                          <v-flex v-if="props.item.file_attach.length > 0">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn @click="attachFiles(props.item)" small icon outline color="primary" v-on="on" class="ma-1" style="width: 24px; height: 24px;">
                                  <v-icon small>attach_file</v-icon>
                                </v-btn>
                              </template>
                              <span> {{ props.item.file_attach.length }} {{ $t('expenses.attachedFiles') }} </span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-else>
                            <v-btn small icon disabled class="ma-1" style="width: 24px; height: 24px;"></v-btn>
                          </v-flex>
                          <v-flex v-if="props.item.receipt_type.id === 2 || props.item.receipt_type.id === 3">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn @click="viewItems(props.item)" small icon outline color="primary" v-on="on" class="ma-1" style="width: 24px; height: 24px;">
                                  <v-icon small>remove_red_eye</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('general.seeMore') }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex v-if="props.item !== null && props.item.receipt_type.id !== 2 && props.item.receipt_type.id !== 3">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn @click="viewItemsF(props.item)" small icon outline color="primary" v-on="on" class="ma-1" style="width: 24px; height: 24px;">
                                  <v-icon small>remove_red_eye</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('general.seeMore') }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex>
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn @click="removed(props.item, false)" small icon outline color="error" v-on="on" class="ma-1" style="width: 24px; height: 24px;">
                                  <v-icon small>clear</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('workflowValidation.rejec') }}</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                        </td>
                      </tr>
                    <tr v-if="props.item.warning_restriction">
                      <td :class="{ 'warning-row': props.item.warning_restriction }" :colspan="headersItems.length + 1" class="warning-text" style="padding: 1px;">
                        <v-icon
                          style="vertical-align: middle"
                          class="warning--text"
                          size="18"
                        >mdi-alert-octagram</v-icon>
                        <span v-html="renderText(props.item.warning_restriction)"></span>
                      </td>
                    </tr>
                      <tr v-if="props.item.tipGet !== 0">
                        <td colspan="4"></td>
                        <td colspan="4">
                          Total + propina = {{ props.item.tipGet }}
                        </td>
                      </tr>
                    </template>
                    <template v-slot:footer>
                      <td colspan="3" class="text-sm-right">
                        <span class="h6 primary--text text-uppercase font-weight-black">{{ $t('general.total') }}:</span>
                      </td>
                      <td colspan="1" class="primary">
                        
                        <span class="h6 font-weight-black white--text">
                          {{
                            type === 'refund'
                            ? new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(Math.abs(repay_back))
                            : new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(totalGlobal + totalTip) }} 
                          {{ tagMoneda }}
                          </span>
                      </td>
                    </template>
                  </v-data-table>
                </div>
                <v-flex
                  xs12
                  class="d-flex flex-row mt-5 text-md-right mr-lg-2"
                  v-if="expenses.length > 0"
                >
                  <v-spacer></v-spacer>
                  <v-flex xs12>
                    <template v-if="item !== null && item.id !== null">
                      <v-menu bottom origin="center center" transition="scale-transition" open-on-hover>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            round
                            small
                            depressed
                            outline
                            color="primary"
                            class="white--text"
                          >
                            {{ $t('documentsDownload.title') }}
                            <v-icon color="error" right dark>
                              mdi-download-multiple
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-list two-line>
                          <v-list-tile
                            v-if="item !== null && item.id !== null"
                            avatar
                            @click="downloadAccuse(item)"
                            :disabled="loadingAccuse"
                          >
                            <v-list-tile-action>
                              <v-icon color="error">mdi-file-pdf-box</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title v-text="$t('documentsDownload.acknowledgment') + '(PDF)'"></v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile
                            v-if="item !== null && item.id !== null"
                            avatar
                            @click="downloadAccuseXls(item)"
                            :disabled="loadingExcelReport"
                          >
                            <v-list-tile-action>
                              <v-icon color="error">mdi-file-excel</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title v-text="$t('documentsDownload.acknowledgmentXLS')"></v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile
                            v-if="item !== null && item.id !== null && item.gst_travel_expenses_request_id !== null"
                            avatar
                            @click="travelExpenseRequestDownload('pdf', item)"
                            :disabled="loadingDownload"
                          >
                            <v-list-tile-action>
                              <v-icon color="error">mdi-file-pdf</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title v-text="$t('documentsDownload.expenseRequestPDF')"></v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile
                            v-if="item !== null && item.id !== null && item.gst_travel_expenses_request_id !== null"
                            avatar
                            @click="travelExpenseRequestDownload('xls', item)"
                            :disabled="loadingDownload"
                          >
                            <v-list-tile-action>
                              <v-icon color="error">mdi-file-excel</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title v-text="$t('documentsDownload.expenseRequestXLS')"></v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile
                            v-if="item !== null && item.id !== null && item.gst_expenses_items && item.gst_expenses_items.length > 0"
                            avatar
                            @click="downloadFilesZip(item)"
                            :disabled="loadingFilesZip"
                          >
                            <v-list-tile-action>
                              <v-icon color="error">mdi-zip-box</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title v-text="$t('documentsDownload.zipFiles')"></v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-flex>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-tab-item>
          <!-- /Validar gastos -->
          <!-- Aprobar gastos -->
          <v-tab-item :key="2" value="tab-2">
            <v-layout class="mt-1 mb-5">
              <v-flex lg3>
                <v-toolbar style="background-color: #F7F9FA !important;" color="bg-sidebar"  height="90">
                  <v-flex class="d-flex flex-column">
                    <!-- <h5 class="mt-5">
                      {{ $t('general.approbe') }}
                      <b-badge pill variant="danger">{{
                        expensesApprobed.length
                      }}</b-badge>
                    </h5> -->
                    <v-text-field
                      color=" "
                      v-model="appSearch"
                      :label="$t('general.search')"
                      clearable
                      @keyup.enter="searching"
                      @click:append="searching"
                    >
                    <template v-slot:append>
                    <v-icon @click="searching">mdi-magnify</v-icon>
                    </template>
                    </v-text-field>
                  </v-flex>
                </v-toolbar>
                <div class="table-container" style="max-height: 500px; overflow-y: auto;">
                  <v-data-table
                    class="elevation-2 mt-2"
                    :headers="headersEx"
                    :items="expensesApprobed"
                    :loading="loadingItems"
                    :pagination.sync="pagination"
                    :items-per-page="pagination.rowsPerPage"
                    :total-items="pagination.totalItems"
                    @update:pagination="checkPageChangeApp"
                  >
                    <template v-slot:items="props">
                      <tr
                        @click="selectRow2(props.item)"
                        class="rowExpense"
                        :class="{ selectedRow: props.item.isSelected }"
                        :key="props.index"
                      >
                        <td class="py-2">
                          <h3 class=" mt-2 font-weight-black primary--text font-weight-black " >
                            #
                            <span class="black--text font-weight-black"> {{ props.item.id }}</span>
                          </h3>
                          <span class="font-weight-black">
                            {{ props.item.user.name }}
                          </span>
                          <br />
                          {{ props.item.description }}
                          <h3 class="mt-2 font-weight-black primary--text font-weight-black">
                            {{ $t('expenses.type') }}:
                            <span class="font-weight-bold type-color"> {{ getTypeText(props.item) }}</span>
                          </h3>
                          <h3 v-if="getType(props.item) === 'refund'" class="mt-2 font-weight-black primary--text font-weight-black">
                            {{ $t('general.amount') }}:
                            <span class="black--text font-weight-black"> {{ Math.abs(props.item.repay_back) | formatCurrency }} {{ tagMoneda }}</span>
                          </h3>
                          <h3 v-if="getType(props.item) === 'advance'" class="mt-2 font-weight-black primary--text font-weight-black">
                            {{ $t('general.amount') }}:
                            <span class="black--text font-weight-black">{{ props.item.advance | formatCurrency }}  {{ tagMoneda }}</span>
                          </h3>
                        </td>
                      </tr>
                    </template>
                    <template v-slot:footer>
                      <td colspan="2" class="text-xs-left">
                        <span
                          class="
                            primary--text
                            text-uppercase
                            font-weight-black
                            h6
                          "
                          >{{ $t('general.totalExpenses') }}:</span
                        >
                        <span
                          class="
                            primary--text
                            text-uppercase
                            font-weight-black
                            h6
                          "
                          >{{ sumaTotalApprobed | formatCurrency }}  {{ tagMoneda }}</span
                        >
                      </td>
                    </template>
                  </v-data-table>
                </div>
              </v-flex>
              <v-flex xs9 class="ml-2">
                <v-flex
                  xs12
                  class="d-flex flex-row"
                  v-if="expensesApprobed.length > 0"
                >
                  <v-flex xs7 class="d-flex flex-column">
                    <h3 class="h3-period">
                      <span class="font-weight-black primary--text"
                        >{{ $t('conciliation.period') }}:
                      </span>
                      {{ dateFormat(startDate) }} - {{ dateFormat(endDate) }}
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            small
                            outline
                            icon
                            v-on="on"
                            compact
                            color="primary"
                            class="ma-0 justify-content-center align-center align-items-center"
                            @click="editExpenseItem(item)"
                          >
                            <v-icon size="small">mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('expenses.editPeriod') }}</span>
                      </v-tooltip>
                    </h3>
                    <v-flex xs12>
                      <v-layout>
                        <v-flex xs6 class="d-flex mb-1">
                          <h3 class="mt-2">
                            <span class="font-weight-black primary--text"
                              >{{ $t('general.project') }}:</span
                            >
                            {{ project }}
                          </h3>
                        </v-flex>
                        <v-flex xs6 class="d-flex mb-1">
                          <h3 class="mt-2">
                            <span class="font-weight-black primary--text">
                              {{ $t('workflowValidation.expenseNo') }}:
                            </span>
                            {{ item && item.id ? item.id : '--' }}
                          </h3>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <h3 class="mt-2 font-weight-black primary--text font-weight-black">
                      {{ $t('general.type') }}:
                      <span class="font-weight-bold type-color">{{ typeText }}</span>
                    </h3>
                    <v-flex class="d-flex flex-column">
                      <h3 v-if="type === 'refund'" class="mt-2 font-weight-black primary--text font-weight-black">
                        {{ $t('expenses.amountOf') }} {{ $t('general.refund') }}:
                        <span class="black--text font-weight-black">
                          {{ Math.abs(repay_back) | formatCurrency }}  {{ tagMoneda }}</span
                        >
                      </h3>
                      <h3 v-if="type === 'advance'" class="mt-2 font-weight-black primary--text font-weight-black">
                        {{ $t('expenses.amountOf') }} {{ $t('general.advance') }}:
                        <span class="black--text font-weight-black"
                          >{{ advance | formatCurrency }}  {{ tagMoneda }}</span
                        >
                      </h3>
                      <h3 v-if="type === 'petty_cash'" class="mt-2 font-weight-black primary--text font-weight-black">
                        {{ $t('general.amount') }}:
                        <span class="black--text font-weight-black">{{ Math.abs(repay_back) | formatCurrency }}  {{ tagMoneda }}</span>
                      </h3>
                      <v-layout v-if="type === 'advance'" class="d-flex flex-row">
                        <v-flex>
                          <h3
                            v-if="isRefund(repay_back) === 'refund'"
                            style="color: tomato"
                            class="mt-2 font-weight-black"
                          >
                            {{ $t('general.refund') }}
                            {{ Math.abs(repay_back) | formatCurrency }}  {{ tagMoneda }}
                          </h3>
                          <h3
                            v-if="isRefund(repay_back) === 'payment'"
                            style="color: #00ab66"
                            class="mt-2 font-weight-black"
                          >
                            {{ $t('general.payment') }}
                            {{ Math.abs(repay_back) | formatCurrency }}  {{ tagMoneda }}
                          </h3>
                        </v-flex>
                      </v-layout>
                      <!-- Propina -->
                      <v-layout v-if="totalTip > 0">
                        <v-flex>
                          <h3
                            class="
                              mt-2
                              font-weight-black
                              primary--text
                              font-weight-black
                            "
                          >
                            Total + propina:
                            <span class="black--text font-weight-black">{{
                              new Intl.NumberFormat('es-MX', {
                                style: 'currency',
                                currency: 'MXN',
                              }).format(totalGlobal + totalTip)
                            }}</span>
                          </h3>
                        </v-flex>
                        <v-flex xs4>
                          <h3
                            class="
                              mt-2
                              font-weight-black
                              primary--text
                              font-weight-black
                            "
                          >
                            Propina:
                            <span class="font-weight-bold black--text"
                              >{{
                                new Intl.NumberFormat('es-MX', {
                                  style: 'currency',
                                  currency: 'MXN',
                                }).format(totalTip)
                              }}
                            </span>
                          </h3>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout class="d-flex flex-row">
                      <v-flex xs6 class="d-flex mb-1">
                        <v-btn
                          v-if="selected.length > 0"
                          color="error"
                          round
                          small
                          depressed
                          @click="selectedExpenseItems()"
                        >
                          {{ $t('workflowValidation.rejec') }}
                        </v-btn>
                      </v-flex>
                      <v-flex xs6 class="d-flex mb-1">
                        <v-btn
                          color="primary"
                          round
                          small
                          depressed
                          @click="confirmApprobed(item)"
                          :disabled="selected.length > 0"
                        >
                          {{ $t('workflowValidation.approbad') }}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout class="d-flex flex-row">
                      <v-flex xs6 class="d-flex mb-1"> </v-flex>
                      <v-flex xs6 class="d-flex mb-1">
                        <div class="text-center">
                          <v-tooltip
                            top
                            v-if="
                              expensesProgress && expensesProgress.length > 0
                            "
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn
                                icon
                                outline
                                large
                                color="primary"
                                v-on="on"
                                @click="openValidatorComment"
                              >
                                <v-icon>mdi-message-alert</v-icon>
                              </v-btn>
                            </template>
                            <span>{{
                              $t('workflowValidation.validatorComments')
                            }}</span>
                          </v-tooltip>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout class="d-flex flex-row">
                      <v-flex xs6 class="d-flex mb-1"> </v-flex>
                      <v-flex xs6 class="d-flex mb-1">
                        <div class="text-center">
                          <v-tooltip
                            top
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn
                                icon
                                outline
                                large
                                color="primary"
                                v-on="on"
                                @click="openBackCheckoutDialog(item)"
                              >
                                <v-icon>mdi-backup-restore</v-icon>
                              </v-btn>
                            </template>
                            <span>{{
                              $t('expenses.backCheckout')
                            }}</span>
                          </v-tooltip>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-flex>
                <div class="table-container" style="max-height: 400px; overflow-y: auto;">
                  <v-data-table
                    v-model="selected"
                    no-data-text="No hay datos que mostrar"
                    :headers="headersItems"
                    :items="expensesItemsApp"
                    :loading="loadingItems"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationItems"
                  >
                    <template v-slot:headers="props">
                      <tr class="bg-heavy-rain">
                        <th>
                          <v-checkbox
                            class="justify-center align-center"
                            :input-value="props.all"
                            :indeterminate="props.indeterminate"
                            color="primary"
                            hide-details
                            @click.stop="toggleAll('Approve')"
                          ></v-checkbox>
                        </th>
                        <th
                          v-for="header in props.headers"
                          :key="header.text"
                          :class="[
                            'column',
                            header.sortable ? 'sortable' : '',
                            paginationItems.descending ? 'desc' : 'asc',
                            header.value === paginationItems.sortBy ? 'active' : '',
                          ]"
                        >
                        <!-- @click="changeSortItems(header.value)" -->
                          <h3 class="font-weight-black primary--text mb-0">
                            <v-icon
                              small
                              class="primary--text"
                              v-if="header.sortable"
                              >arrow_upward</v-icon
                            >
                            {{ header.text }}
                          </h3>
                        </th>
                      </tr>
                    </template>
                    <template v-slot:items="props">
                      <tr v-if="props.item.has_multiprojects && props.item.isTitle && props.item.project_id" style="background-color: lightblue">
                        <td colspan="9"><b>{{ $t('general.project') }} : {{ props.item.projectName }}</b></td>
                      </tr>
                      <tr >
                        <td colspan="2" style="padding: 3px;" :class="{'custom-row-color': props.item.gst_receipt_types_id === 4,'warning-rows': props.item.warning_restriction}">
                          <div style="display: flex; align-items: center;">
                            <v-checkbox
                              :input-value="props.selected"
                              :disabled="props.item.gst_receipt_types_id === 4"
                              color="primary"
                              hide-details
                              v-model="props.selected"
                              style="margin-right: 1px;"
                            ></v-checkbox>
                            <span style="margin-left: -10px; margin-right: -3px;" :class="{ 'warning-rows': props.item.warning_restriction}"> <!-- Reducción de margen izquierdo y añadido margen derecho al span -->
                              {{ props.item.id }}
                            </span>
                            <!-- <div
                              class="text-center"
                              v-if="props.item.warning_restriction"
                              style="margin-left: 5px;"
                            >
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <v-icon
                                    style="vertical-align: middle"
                                    v-if="props.item.warning_restriction"
                                    class="warning--text"
                                    size="18"
                                    v-on="on"
                                  >mdi-alert-octagram</v-icon>
                                </template>
                                {{ props.item.warning_restriction }}
                              </v-tooltip>
                            </div> -->
                          </div>
                        </td>
                        <td :class="{'custom-row-color': props.item.gst_receipt_types_id === 4, 'warning-rows': props.item.warning_restriction}">{{ props.item.description }}</td>
                        <td :class="{'custom-row-color': props.item.gst_receipt_types_id === 4, 'warning-rows': props.item.warning_restriction}">
                          {{
                            props.item.gst_categories
                              ? props.item.gst_categories.name
                              : ''
                          }}
                        </td>
                        <td :class="{'custom-row-color': props.item.gst_receipt_types_id === 4, 'warning-rows': props.item.warning_restriction}">{{ props.item.total | formatCurrency }}</td>
                        <td :class="{'custom-row-color': props.item.gst_receipt_types_id === 4, 'warning-rows': props.item.warning_restriction}">{{ parseFloat(props.item.exchange).toFixed(2) }}</td>
                        <td :class="{'custom-row-color': props.item.gst_receipt_types_id === 4, 'warning-rows': props.item.warning_restriction}">{{ props.item.total_mxn | formatCurrency }}</td>
                        <td :class="{'custom-row-color': props.item.gst_receipt_types_id === 4, 'warning-rows': props.item.warning_restriction}">{{ props.item.currency_sat.c_Moneda }}</td>
                        <td :class="{'custom-row-color': props.item.gst_receipt_types_id === 4, 'warning-rows': props.item.warning_restriction}" style="width: 15%">
                        <v-layout v-if="props.item.gst_receipt_types_id !== 4" row>
                          <v-flex style="margin-left: inherit;" v-if="props.item.file_attach.length > 0">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn @click="attachFiles(props.item)" small icon outline color="primary" v-on="on" class="ma-1" style="width: 24px; height: 24px;">
                                  <v-icon small>attach_file</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ props.item.file_attach.length }} {{ $t('expenses.attachedFiles') }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex style="margin-left: inherit;" v-else>
                            <v-btn small icon disabled class="ma-1" style="width: 24px; height: 24px;"></v-btn>
                          </v-flex>
                          <v-flex style="margin-left: inherit;" v-if="props.item.gst_receipt_types.id === 2 || props.item.gst_receipt_types.id === 3">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn @click="viewItemsApprobed(props.item)" small icon outline color="primary" v-on="on" class="ma-1" style="width: 24px; height: 24px;">
                                  <v-icon small>remove_red_eye</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('general.seeMore') }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex style="margin-left: inherit;" v-if="props.item !== null && props.item.gst_receipt_types.id !== 2 && props.item.gst_receipt_types.id !== 3">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn @click="viewItemsApprobedF(props.item)" small icon outline color="primary" v-on="on" class="ma-1" style="width: 24px; height: 24px;">
                                  <v-icon small>remove_red_eye</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('general.seeMore') }}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex style="margin-left: inherit;">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn @click="removedApprobed(props.item, false)" small icon outline color="error" v-on="on" class="ma-1" style="width: 24px; height: 24px;">
                                  <v-icon small>clear</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t('workflowValidation.rejec') }}</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </td>
                      </tr>
                      <tr v-if="props.item.warning_restriction">
                      <td :class="{ 'warning-row': props.item.warning_restriction }" :colspan="headersItems.length + 1" class="warning-text" style="padding: 1px;">
                        <v-icon
                          style="vertical-align: middle"
                          class="warning--text"
                          size="18"
                        >mdi-alert-octagram</v-icon>
                        <span v-html="renderText(props.item.warning_restriction)"></span>
                      </td>
                      </tr>
                      <tr v-if="props.item.tipGet !== 0">
                        <td colspan="4"></td>
                        <td colspan="4">
                          Total + propina = {{ props.item.tipGet }}
                        </td>
                      </tr>
                    </template>
                    <template v-slot:footer>
                      <td colspan="3" class="text-sm-right">
                        <span
                          class="
                            h6
                            primary--text
                            text-uppercase
                            font-weight-black
                          "
                          >{{ $t('general.total') }}:</span
                        >
                      </td>
                      <td colspan="1" class="primary">
                        <span class="h6 font-weight-black white--text">
                          {{
                            new Intl.NumberFormat('es-MX', {
                              style: 'currency',
                              currency: 'MXN',
                            }).format(suma_total_itemsApp + totalTip)
                          }}
                          {{ tagMoneda }}</span
                        >
                      </td>
                    </template>
                  </v-data-table>
                </div>
                <v-flex
                  xs12
                  class="d-flex flex-row mt-5 text-md-right mr-lg-2"
                  v-if="expensesApprobed.length > 0"
                >
                  <v-spacer></v-spacer>
                  <v-flex xs12>
                    <template v-if="item !== null && item.id !== null">
                      <v-menu bottom origin="center center" transition="scale-transition" open-on-hover>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            round
                            small
                            depressed
                            outline
                            color="primary"
                            class="white--text"
                          >
                            {{ $t('documentsDownload.title') }}
                            <v-icon color="error" right dark>
                              mdi-download-multiple
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-tile
                            v-if="item !== null && item.id !== null"
                            avatar
                            @click="downloadAccuse(item)"
                            :disabled="loadingAccuse"
                          >
                            <v-list-tile-action>
                              <v-icon color="error">mdi-file-pdf-box</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title v-text="$t('documentsDownload.acknowledgment')"></v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile
                            v-if="item !== null && item.id !== null"
                            avatar
                            @click="downloadAccuseXls(item)"
                            :disabled="loadingExcelReport"
                          >
                            <v-list-tile-action>
                              <v-icon color="error">mdi-file-excel</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title v-text="$t('documentsDownload.acknowledgment') + ' .xls'"></v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile
                            v-if="item !== null && item.id !== null && item.gst_travel_expenses_request_id !== null"
                            avatar
                            @click="travelExpenseRequestDownload('pdf', item)"
                            :disabled="loadingDownload"
                          >
                            <v-list-tile-action>
                              <v-icon color="error">mdi-file-pdf</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title v-text="$t('documentsDownload.expenseRequestPDF')"></v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile
                            v-if="item !== null && item.id !== null && item.gst_travel_expenses_request_id !== null"
                            avatar
                            @click="travelExpenseRequestDownload('xls', item)"
                            :disabled="loadingDownload"
                          >
                            <v-list-tile-action>
                              <v-icon color="error">mdi-file-excel</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title v-text="$t('documentsDownload.expenseRequestXLS')"></v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile
                            v-if="item !== null && item.id !== null && item.items && item.items.length > 0"
                            avatar
                            @click="downloadFilesZip(item)"
                            :disabled="loadingFilesZip"
                          >
                            <v-list-tile-action>
                              <v-icon color="error">mdi-zip-box</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title v-text="$t('documentsDownload.zipFiles')"></v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-flex>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-tab-item>
          <!-- /Aprobar gastos -->
        </v-tabs-items>
      </v-card>
      <!-- /TABS -->
      <v-dialog v-model="dialogTip" max-width="600px" scrollable persistent>
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ formTitleTip }}
            </h2>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-form ref="tipForm" lazy-validation>
                  <v-container>
                    <v-layout row wrap>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="editedItemTip.amount"
                          :error-messages="errors.amount"
                          :rules="rules.required"
                          :label="$t('general.amount')"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 layout v-if="dataURL">
                        <v-flex xs12>
                          <label>{{ $t('expenses.file') }}:</label>
                          <a v-if="!isPDF(dataURL)" @click="openPDF()">
                            <zoom-on-hover
                              :img-normal="dataURL"
                            ></zoom-on-hover>
                          </a>
                          <v-btn
                            block
                            v-if="isPDF(dataURL)"
                            @click="openPDF()"
                            color="primary"
                            depressed
                          >
                            <v-icon left>insert_drive_file</v-icon>
                            {{ $t('expenseItems.watchFile') }}
                          </v-btn>
                          <iframe
                            v-if="isPDF(dataURL)"
                            :src="dataURL"
                            frameborder="0"
                            width="100%"
                            height="400px"
                          ></iframe>
                        </v-flex>
                      </v-flex>
                      <v-flex xs12>
                        <vue-dropzone
                          v-if="editedItemTip.created_at === ''"
                          ref="dropzone"
                          id="dropzone"
                          :options="dropzoneOptions"
                          v-on:vdropzone-file-added="fileAdded"
                          v-on:vdropzone-error="fileUploadError"
                          v-on:vdropzone-success="fileUploadTip"
                        >
                        </vue-dropzone>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="editedItemTip.created_at !== ''"
              round
              flat
              color="primary darken-1"
              @click="closeDialogTip()"
            >
              {{ $t('general.close') }}
            </v-btn>
            <v-btn
              v-if="editedItemTip.created_at === ''"
              round
              flat
              color="primary darken-1"
              @click="closeDialogTip()"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              v-if="editedItemTip.created_at === ''"
              round
              color="primary"
              :loading="loading"
              :disabled="loading"
              @click="submitTip()"
            >
              {{ $t('general.submit') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="validatorCommentDialog"
        max-width="800px"
        persistent
        scrollable
      >
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('workflowValidation.validatorComments') }}
            </h2>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row>
                <v-flex xs12>
                  <v-data-table
                    class="elevation-1"
                    :headers="headersCommentValidators"
                    :items="expensesProgress.length > 0 ? expensesProgress : []"
                    :rows-per-page-items="[10, 15, 25]"
                    :pagination.sync="validatorCommentPagination"
                    hide-actions
                  >
                    <template v-slot:headers="props">
                      <tr class="bg-heavy-rain">
                        <th
                          v-for="header in props.headers"
                          :key="header.text"
                          :class="[
                            'column',
                            header.sortable ? 'sortable' : '',
                            validatorCommentPagination.descending
                              ? 'desc'
                              : 'asc',
                            header.value === validatorCommentPagination.sortBy
                              ? 'active'
                              : '',
                          ]"
                          @click="changeSort(header.value)"
                        >
                          <h2 class="font-weight-black primary--text mb-0">
                            <v-icon
                              small
                              class="primary--text"
                              v-if="header.sortable"
                              >arrow_upward</v-icon
                            >
                            {{ header.text }}
                          </h2>
                        </th>
                      </tr>
                    </template>
                    <template v-slot:items="props">
                      <tr>
                        <td class="text-sm-center">
                          {{
                            props.item.user && props.item.user.name
                              ? props.item.user.name
                              : ''
                          }}
                        </td>
                        <td class="text-sm-center">{{ props.item.comment }}</td>
                        <td class="text-sm-center">
                          {{ props.item.created_at }}
                        </td>
                        <td class="text-sm-center">
                          <template>
                            <v-chip
                              color="bg-success"
                              class="font-weight-black"
                              dark
                              small
                            >
                              {{ props.item.status }}
                            </v-chip>
                          </template>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat round @click="close">
              {{ $t('general.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Dialogo para regresar la comprobación al estatus "Creado" -->
      <v-dialog
        v-model="backCheckoutDialog"
        max-width="700px"
        persistent
        scrollable
      >
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('expenses.backCheckout') }}
            </h2>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-layout row>
                <v-flex xs12>
                  <v-card-text>
                    <span class="mb-6"
                      v-html="
                        $t('expenses.attentionBackCheckout', {
                          expenseId: itemBackCheckoutDialog.expenseId,
                          userName: itemBackCheckoutDialog.userName
                        })
                      "
                    ></span>
                    <v-form lazy-validation ref="backCheckoutDialogForm" v-model="validBackCheckout">
                      <v-textarea
                        required
                        :label="$t('general.comment')"
                        v-model="itemCommentBackCheckout"
                        rows="2"
                        :rules="rules.required"
                      ></v-textarea>
                    </v-form>
                  </v-card-text>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="editedItemTip.created_at === ''"
              round
              flat
              color="primary darken-1"
              @click="close()"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              v-if="editedItemTip.created_at === ''"
              round
              color="primary"
              :loading="loading"
              :disabled="loading"
              @click="submitBackCheckout()"
            >
              {{ $t('general.accept') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Diálogo para editar comprobación -->
      <v-dialog v-model="dialogEditExpenseItem" max-width="600px" persistent>
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ this.$t('expenses.edit') }}
            </h2>
          </v-toolbar>
          <v-card-text>
            <v-form lazy-validation ref="dialogEditExpenseItemForm" v-model="valid">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-menu
                      v-model="expenseItemStart"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          clearable
                          required
                          :rules="rules.required"
                          :error-messages="errors.start_date"
                          v-model="editedItemExpense.start_date"
                          :label="$t('general.startDate')"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        >
                        </v-text-field>
                      </template>
                      <v-date-picker
                        color="primary"
                        :locale="$t('general.locale')"
                        v-model="editedItemExpense.start_date"
                        :max="maxDate"
                        @input="expenseItemStart = false"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-menu
                      v-model="expenseItemEnd"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          clearable
                          required
                          :rules="rules.required"
                          v-model="editedItemExpense.end_date"
                          :error-messages="errors.end_date"
                          :label="$t('general.endDate')"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        >
                        </v-text-field>
                      </template>
                      <v-date-picker
                        color="primary"
                        :locale="$t('general.locale')"
                        v-model="editedItemExpense.end_date"
                        :min="minDate"
                        @input="expenseItemEnd = false"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" round flat @click="close">
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              round
              depressed
              :loading="loading"
              :disabled="loading"
              @click="expenseUpdate()"
            >
              {{ $t('general.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <!-- Overlay -->
    <div class="overlay" v-if="overlay"></div>
  </div>
</template>

<script>
/* eslint-disable */
import vue2Dropzone from 'vue2-dropzone'
import {mapGetters} from 'vuex';
export default {
  name: 'expensesValidateComponent',
  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      totalValidate: 0,
      totalApprobed: 0,
      editItemCategories: {},
      titleTagCategory: this.$t('general.category'),
      page: 'expenseValidate',
      concepts:[],
      conceptos: [],
      editCategory: false,
      editCategoryF: false,
      editCategoryAppF: false,
      tagMoneda: '',
      settings: {},
      currencySetting: {},
      initialPage: true,
      initialPageApp: true,
      dialogFile: false,
      dialogViewFile: false,
      editedItemFile: {
        id: '',
        description: '',
        gst_categories: {
          name: ''
        },
        file_attach: []
      },
      loadingFile: false,
      loadFile: false,
      loadBtn: false,
      loadItem: true,
      uploadedFiles: [],
      arrayFiles: [],
      dataURLFile: null,
      watchItem: {
        files_type_id: 0
      },
      dropzoneOptionsFile: {
        url: process.env.HOST + 'api/File',
        dictDefaultMessage: this.$t('dropzone.default', { size: '5', unit: 'MB' }),
        dictResponseError: this.$t('dropzone.responseError'),
        dictFileTooBig: this.$t('dropzone.fileTooBig'),
        dictInvalidFileType: this.$t('dropzone.invalidFileType'),
        dictRemoveFile: this.$t('dropzone.removeFile'),
        dictRemoveFileConfirmation: this.$t('dropzone.removeFileConfirmation'),
        dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
        addRemoveLinks: true,
        thumbnailWidth: 150,
        maxFilesize: 5,
        paramName: 'path',
        acceptedFiles: '.jpeg,.jpg,.png,.pdf,.zip',
        // maxFiles: 1,
        headers: { 'Authorization': 'Bearer ' + this.$store.state.userState.access_token },
        params: {
          'user_id': this.$store.state.userLogged.id,
          'dirname': 'ATTACHMENT_EXPENSES'
        }
      },
      isExpenseApprovalView: false,
      overlay: false,
      validateBtn: false,
      totalTip: 0,
      totalGlobal: 0,
      rejectedFromDialog: false,
      type: '',
      project: '',
      loadingDownload: false,
      loadingAccuse: false,
      loadingFilesZip: false,
      lastIndex: 0,
      lastIndexApp: 0,
      tab: null,
      receipt_type: '',
      showPrevious: true,
      showNext: true,
      isDataLoaded: false,
      isDataAppLoaded: false,
      suma_total_items: 0,
      suma_total_itemsApp: 0,
      item: null,
      isPettyCash: null,
      advance: 0,
      startDate: null,
      endDate: null,
      refund: 0,
      payment: 0,
      repay_back: 0,
      expensesItems: [],
      expensesItemsApp: [],
      loadingExpensesItems: false,
      categories: [],
      errors: {},
      valSearch: '',
      appSearch: '',
      loadingXML: false,
      pagination: {
        rowsPerPage: 10,
        sortBy: 'id',
        descending: true,
        page: 1,
        totalItems: 0
      },
      defaultPagination: {
        rowsPerPage: 10,
        sortBy: 'id',
        descending: true,
        page: 1,
        totalItems: 0
      },
      paginationItems: {
        rowsPerPage: 25,
        descending: false,
      },
      rowsPerPage: [10, 15, 26],
      rowsPerPageItems: [
        { text: '10', value: 10 },
        { text: '15', value: 15 },
        { text: '25', value: 25 },
        { text: this.$t('general.all'), value: -1 }
      ],
      userloggeds: {
      },
      expenses: [],
      validatorSubtitute: {
        typeUser: '',
      },
      editedItem: {
        gst_categories: {},
        country: {},
        currency: {},
        sat_forma_pago: {},
        receipt_type: {
          name: 'name',
        },
        sat_metodo_pago: {},
        validator_comment: '',
        foreign_tax: {},
        item_lines: []
      },
      editedItemApprobedF: {
        item_lines: [],
        gst_categories: {},
        country: {},
        currency: {},
        sat_forma_pago: {},
        gst_receipt_types: {
          name: '',
        },
        sat_metodo_pago: {},
        validator_comment: '',
      },
      defaultItem: {
        name: '',
        gst_categories: {},
        country: {},
        currency: {},
        sat_forma_pago: {},
        gst_receipt_types: {
          name: '',
        },
        sat_metodo_pago: {},
        validator_comment: '',
      },
      itemsApprobedView: {
        gst_categories: {},
        country_sat: {},
        currency_sat: {},
        sat_forma_pago: {},
        gst_receipt_types: {
          name: '',
        },
        validator_comment: '',
      },
      defaultItemA: {
        name: '',
        gst_categories: {},
        country_sat: {},
        currency_sat: {},
        sat_forma_pago: {},
        gst_receipt_types: {
          name: '',
        },
        validator_comment: '',
      },
      dialog: false,
      dialogValidateF: false,
      dialogApprobedF: false,
      removedItem: {},
      removedItemF: {},
      removedItemApprobedF: {},
      itemsApprobedRemoved: {},
      removeDialog: false,
      removeDialogF: false,
      validat: {
        user: {},
      },
      approbed: {
        user: {},
      },
      general: {
        validator_comment: '',
      },
      expensesApprobed: [],
      dialogValidate: false,
      dialogApprobed: false,
      dialogApprobedView: false,
      removeDialogApprobed: false,
      dialogF: false,
      dialogTip: false,
      valid: true,
      valid2: true,
      validF: true,
      approvedFiscalValid: true,
      approvedNoFiscalValid: true,
      loading: false,
      loadingItems: false,
      disabled: false,
      dialogNew: false,
      itemsNew: {
        user: {},
      },
      cfdiHtml: null,
      cfdiDialog: false,
      dataURL: null,
      itemsNewApprobed: {
        user: {},
      },
      dialogNewApprobed: false,
      sumaTotalApprobed: 0,
      sumaTotal: 0,
      editedItemTip: {
        id: null,
        amount: null,
        fileId: null,
        created_at: '',
      },
      defaultItemTip: {
        id: null,
        amount: null,
        fileId: null,
        created_at: '',
      },
      expensesProgress: [],
      validatorCommentDialog: false,
      selected: [],
      multipleSelectedRejec: false,
      rejectedSelectedDialog: false,
      rejectedSelectedId: [],
      validatorCommentPagination: {
        descending: true,
        sortBy: 'created_at',
        page: 1,
        rowsPerPage: -1, // -1 for All",
        totalItems: 0,
      },
      dropzoneOptions: {
        url: process.env.HOST + 'api/File',
        dictDefaultMessage: this.$t('dropzone.default', {
          size: '5',
          unit: 'MB',
        }),
        dictResponseError: this.$t('dropzone.responseError'),
        dictFileTooBig: this.$t('dropzone.fileTooBig'),
        dictInvalidFileType: this.$t('dropzone.invalidFileType'),
        dictRemoveFile: this.$t('dropzone.removeFile'),
        dictRemoveFileConfirmation: this.$t('dropzone.removeFileConfirmation'),
        dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
        addRemoveLinks: true,
        thumbnailWidth: 150,
        maxFilesize: 5,
        paramName: 'path',
        acceptedFiles: '.jpeg,.jpg,.png,.pdf',
        maxFiles: 1,
        headers: {
          Authorization: 'Bearer ' + this.$store.state.userState.access_token,
        },
        params: {
          user_id: this.$store.state.userLogged.id,
          dirname: 'IMG_EXPENSES',
        },
      },
      travelRequestDownloadList: [
          { icon: true, title: 'DOS', iconMdi: 'mdi-file-pdf' },
          { icon: true, title: 'PDF', iconMdi: 'mdi-file-pdf' },
          { icon: true, title: 'XLS', iconMdi: 'mdi-file-excel' }
      ],
      closeOnClickVals: true,
      backCheckoutDialog: false,
      itemCommentBackCheckout: '',
      validBackCheckout: true,
      loadingExcelReport: false,
      itemBackCheckoutDialog: {
        expenseId: '',
        userName: ''
      },
      dialogEditExpenseItem: false,
      expenseItemStart: false,
      expenseItemEnd: false,
      editedItemExpense: {
        id: null,
        user_id: null,
        start_date: '',
        end_date: '',
        description: '',
        project_id: '',
        status: '',
        expenses_status: '',
        advance: 0,
        is_petty_cash: false,
        viatic_request_id: null,
        has_request: false
      },
      defaultItemExpense: {
        id: null,
        user_id: null,
        start_date: '',
        end_date: '',
        description: '',
        project_id: '',
        status: '',
        expenses_status: '',
        advance: 0,
        is_petty_cash: false,
        viatic_request_id: null,
        has_request: false
      },
      pagingStorageGeneral: null
    }
  },
  created() {
    if (this.paginated && this.paginated.item && this.paginated.pagination) {
      this.pagingStorageGeneral = this.paginated;
      this.pagination = this.pagingStorageGeneral.pagination
    } else {
      this.pagingStorageGeneral = null
    }
    if (this.pagingStorageGeneral && this.pagingStorageGeneral.pagination && this.pagingStorageGeneral.pagination.page !== this.pagination.page) {
        this.deleteLocalStorage()
    }
    this.getLogged()
  },
  watch: {
    settings(){
      this.filterCurrency()
    },
    userloggeds() {
      if(this.userloggeds.validator === null) return this.getEApprobed()
      this.get()
      
      // this.selectRow()
      // this.selectRow2()
    },
    // dialog (val) {
    //   val || this.close()
    // },
    '$store.state.userLogged'() {
      this.getLogged()
    },
    'itemsNew.gst_expenses_items'() {
      if (
        this.itemsNew.gst_expenses_items !== undefined &&
        this.itemsNew.gst_expenses_items !== null
      ) {
        if (this.itemsNew.gst_expenses_items.length === 0) {
          this.closeNewItems()
        }
      }
    },
    expenses(val) {
      if (val.length > 0 && !this.isDataLoaded) {
        this.selectRow()
        this.isDataLoaded = true
      }
      if (val.length === 0) {
        this.expensesItems = []
      }
    },
    expensesApprobed(val) {
      if (val.length > 0 && !this.isDataAppLoaded) {
        this.selectRow2()
        this.isDataAppLoaded = true
      }
      if (val.length === 0) {
        this.expensesItemsApp = []
      }
    },
    tab() {
      this.selected = []
      this.multipleSelectedRejec = false
    },
    valSearch(val) {
      if (val === '' || val === null) this.searching()
    },
    appSearch(val) {
      if (val === '' || val === null) this.searching()
    },
  },
  computed: {
    applyFeatures(){
      if(this.$store.state.userLogged.company === undefined){
        return false
      }

      if(this.$store.state.userLogged.company[0].features.find(x => x.name === 'EXPENSE_LINES')){
        return true
      }

      return false
    },
    conceptsHeaderUniversal() {
      return [
      {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: false
        },
        {
          text: this.$t('general.amount'),
          value: 'amount',
          sortable: false
        },
        {
          text: this.$t('general.iva'),
          align: 'center',
          value: 'amount',
          sortable: false
        },
        {
          text: this.$t('general.category'),
          align: 'center',
          value: 'category',
          sortable: false
        },
      ]
    },
    conceptsHeader() {
      return [
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: false
        },
        {
          text: this.$t('general.amount'),
          align: 'center',
          value: 'amount',
          sortable: false
        },
        {
          text: this.$t('general.category'),
          align: 'center',
          value: 'category',
          sortable: false
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          value: 'actions',
          sortable: false
        }
      ]
    },
    conceptsHeaderAppF() {
      return [
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: false
        },
        {
          text: this.$t('general.amount'),
          align: 'center',
          value: 'amount',
          sortable: false
        },
        {
          text: this.$t('general.category'),
          align: 'center',
          value: 'category',
          sortable: false
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          value: 'actions',
          sortable: false
        }
      ]
    },
    fileWatchType () {
      if (this.watchItem.files_type_id) {
        switch (this.watchItem.files_type_id) {
          case 3:
            return 'pdf'
          case 9:
            return 'rar'
          case 12:
            return 'zip'
          case 5:
            return 'jpeg'
          case 6:
            return 'png'
          default:
            return 'img'
        }
      }
    },
    ...mapGetters(['paginated']),
    headersEx() {
      return [
        {
          text: this.$t('general.expense'),
          align: 'left',
          value: 'description',
          sortable: true,
        },
      ]
    },
    headersItems() {
      return [
        {
          text: '#',
          align: 'left',
          value: 'id',
          sortable: false,
        },
        {
          text: this.$t('general.description'),
          align: 'left',
          value: 'description',
          width: '500px',
          sortable: false,
        },
        {
          text: this.$t('general.category'),
          align: 'left',
          value: 'gst_categories.name',
          sortable: false,
        },
        {
          text: this.$t('general.subtotal'),
          align: 'left',
          value: 'total_mxn',
          sortable: false,
        },
        {
          text: this.$t('general.exchangeRate'),
          align: 'left',
          value: 'exchange',
          sortable: false,
        },
        {
          text: `${this.$t('general.total')} ${this.tagMoneda}`,
          align: 'left',
          value: 'total',
          sortable: false,
        },
        {
          text: this.$t('general.currency'),
          align: 'left',
          value: 'currency_sat.c_Moneda',
          sortable: false,
        },
        {
          text: this.$t('general.actions'),
          align: 'left',
          sortable: false,
        },
      ]
    },
    headersCommentValidators() {
      return [
        {
          text: this.$t('validator.name'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('general.comment'),
          align: 'center',
          value: 'created_at',
          sortable: false,
        },
        {
          text: this.$t('general.date'),
          align: 'center',
          value: 'description',
          sortable: false,
        },
        {
          text: this.$t('general.expenseStatus'),
          align: 'center',
          value: 'amount',
          sortable: false,
        },
      ]
    },
    heading() {
      return this.$t('general.check')
    },
    subheading() {
      return ''
    },
    icon() {
      return 'fas fa-money-check-alt fa-fw icon-color'
    },
    rules() {
      return this.$validationRules()
    },
    editable() {
      if (this.editedIndex > -1) {
        if (
          this.editedItem.created_by &&
          this.editedItem.created_by.id !== this.$store.state.userLogged.id
        ) {
          return true
        } else {
          return false
        }
      }
    },
    // view (editedItem) {
    //   if (this.viewItems()) {
    //     return this.editedItem.clean(this.editedItem.sat_metodo_pago)
    //   } else {
    //     return this.editedItem.sat_metodo_pago
    //   }
    // },
    formTitleTip() {
      if (this.editedItemTip.created_at !== '') {
        return this.$t('expenses.tip')
      } else {
        return ''
      }
    },
    minDate () {
      let minDate = ''
      if (
        this.editedItemExpense.start_date !== '' &&
        this.editedItemExpense.start_date !== null
      ) {
        minDate = new Date(this.editedItemExpense.start_date)
          .toISOString()
          .substr(0, 10)
        const expenseItems = this.tab === 'tab-1' ? this.editedItemExpense.gst_expenses_items : this.editedItemExpense.items
        if (expenseItems && expenseItems.length > 0) {
          const minorDate = expenseItems.reduce((previousDate, expItem) => {
            const currentDate = expItem.date;
            if (currentDate) {
              return currentDate > previousDate ? currentDate : previousDate;
            } else {
              return null
            }
          }, expenseItems[0].date);
          if (minorDate) {
            minDate = new Date(minorDate).toISOString().substr(0, 10)
          }
        }
      }
      return minDate
    },
    maxDate () {
      let maxDate = ''
      if (
        this.editedItemExpense.end_date !== '' &&
        this.editedItemExpense.end_date !== null
      ) {
        maxDate = new Date(this.editedItemExpense.end_date).toISOString().substr(0, 10)
        const expenseItems = this.tab === 'tab-1' ? this.editedItemExpense.gst_expenses_items : this.editedItemExpense.items
        if (expenseItems && expenseItems.length > 0) {
          const minorDate = expenseItems.reduce((previousDate, expItem) => {
            const currentDate = expItem.date;
            if (currentDate) {
              return currentDate < previousDate ? currentDate : previousDate;
            } else {
              return null
            }
          }, expenseItems[0].date);
          if (minorDate) {
            maxDate = new Date(minorDate).toISOString().substr(0, 10)
          }
        }
      }
      return maxDate
    }
  },
  methods: {
    editConceptsCategory(item, index){
      this.$set(this.editItemCategories, index, !this.editItemCategories[index])
    },
    showEditCategory(){
      this.concepts = JSON.parse(JSON.stringify(this.editedItem.item_lines))
      this.concepts.forEach(item => { item.editCategory = false });
      this.editCategory = !this.editCategory
      this.titleTagCategory = !this.editCategory ? this.$t('general.category') : this.$t('general.expense') 
    },
    showEditCategoryApprobed(){
      this.concepts = JSON.parse(JSON.stringify(this.itemsApprobedView.item_lines))
      this.concepts.forEach(item => { item.editCategory = false });
      this.editCategory = !this.editCategory
      this.titleTagCategory = !this.editCategory ? this.$t('general.category') : this.$t('general.expense') 
    },
    showEditCategoryF(){
      this.conceptos = JSON.parse(JSON.stringify(this.editedItem.item_lines))
      this.conceptos.forEach(item => { item.editCategoryF = false });
      this.editCategoryF = !this.editCategoryF
      this.titleTagCategory = !this.editCategoryF ? this.$t('general.category') : this.$t('general.expense') 
    },
    showEditCategoryApprF(){
      this.conceptos = JSON.parse(JSON.stringify(this.editedItemApprobedF.item_lines))
      this.conceptos.forEach(item => { item.editCategoryAppF = false });
      this.editCategoryAppF = !this.editCategoryAppF
      this.titleTagCategory = !this.editCategoryAppF ? this.$t('general.category') : this.$t('general.expense')
    },
    filterCurrency() {
    const foundCurrencySetting = this.settings.find(x => x.setting_type.name == "st.currency" && x.company_id == this.$store.state.userLogged.company[0].id)
    this.currencySetting = foundCurrencySetting ? foundCurrencySetting : { value: { c_Moneda: 'MXN' } }
    this.tagMoneda = this.currencySetting.value.c_Moneda
    this.editedItem.currency = this.currencySetting.value
    this.defaultItem.currency = this.currencySetting.value
    },
    fileAdded (file) {
      this.dropzoneOptionsFile.params.user_id = this.$store.state.userLogged.id
      let fileType = file.type
      switch (fileType) {
        case 'image/jpeg':
          this.dropzoneOptionsFile.params.files_type_id = 5
          break
        case 'image/png':
          this.dropzoneOptionsFile.params.files_type_id = 6
          break
        case 'application/pdf':
          this.dropzoneOptionsFile.params.files_type_id = 3
          break
        case 'application/zip':
        case 'application/x-zip-compressed':
          this.dropzoneOptionsFile.params.files_type_id = 12
          break
        case 'application/rar':
          this.dropzoneOptionsFile.params.files_type_id = 9
          break
        default:
          this.dropzoneOptionsFile.params.files_type_id = null
          break
      }
    },
    renderText(text) {
      return text.replace(/<br\s*\/?>/g, '<br>');
    },
    watchFile (item) {
      this.dialogViewFile = true
      this.watchItem = item
      this.loadFile = true
      if (item.files_type_id === 9 || item.files_type_id === 12) {
        this.$store.dispatch('getZip', {
          event: {
            context: this,
            fileId: item.id
          }
        })
      } else {
        this.$store.dispatch('getFile', {
          event: {
            context: this,
            fileId: item.id
          }
        })
      }
    },
    downloadFile () {
      this.loadBtn = true
      this.$store.dispatch('getZip', {
        event: {
          context: this,
          fileId: this.watchItem.id
        }
      })
    },
    closeDialogFiles () {
      this.dialogFile = false
      this.loadItem = true
      this.loadFile = false
      this.dataURLFile = null
      this.dialogViewFile = false
    },
    closeViewFile(){
      this.dialogViewFile = false
      this.loadFile = false
      this.dataURLFile = null
    },
    attachFiles(item) {
      this.dialogFile = true
      this.$emit('getItem', {id: item.id, context: this})
      
      // this.savePagingStorage(item)
      // this.$router.push('/expenses/files/watch/' + item.id)

      // if (item && this.pagination) {
      //   const data = {
      //     item: this.item,
      //     pagination: this.pagination
      //   }
      //   localStorage.setItem('pagingStorage', JSON.stringify(data))
      // }
    },
    downloadRequest(item) {
      this.loadingDownload = true
      this.$emit('downloadRequest', {
        context: this,
        expensesRequest: item.travel_expenses_request
          ? item.travel_expenses_request.id
          : item.gst_travel_expenses_request_id,
        folio: item.travel_expenses_request.folio,
      })
    },
    downloadAccuse(item) {
      this.loadingAccuse = true
      this.$emit('downloadAccuse', {
        id: item.id,
        context: this,
      })
    },
    downloadAccuseXls(item) {
      this.loadingExcelReport = true
      this.$emit('downloadExcelReport', {
        id: item.id,
        context: this,
      })
    },
    downloadFilesZip(item) {
      this.loadingFilesZip = true
      if (item.user_id) {
        this.$emit('downloadFilesZip', {
          item: {
            id: item.id,
            user_id: item.user_id
          },
          context: this,
        })
      }
    },
    viewValidated() {
      this.pagination = Object.assign({}, this.defaultPagination)
      this.tab = 'tab-1'
      this.get()
      // this.selectRow()
      this.deleteLocalStorage()
    },
    viewApprobed() {
      this.valSearch = ''
      this.pagination = Object.assign({}, this.defaultPagination)
      this.getEApprobed()
      this.tab = 'tab-2'
      this.selectRow2()
      this.deleteLocalStorage()
    },
    nextExpense(item) {
      if (this.expenses.length > 0) {
        let index = this.expenses.findIndex((x) => x.id === item.id)
        if (index <= this.expenses.length - 2) {
          this.selectRow(this.expenses[index + 1])
          if (index === this.pagination.rowsPerPage - 1) {
            this.pagination.page++
          }
        } else {
          this.selectRow(this.expenses[0])
          this.pagination.page = 1
        }
      }
    },
    nextExpense2(item) {
      if (this.expensesApprobed.length > 0) {
        let index = this.expensesApprobed.findIndex((x) => x.id === item.id)
        if (index <= this.expensesApprobed.length - 2) {
          this.selectRow2(this.expensesApprobed[index + 1])
          if (index === this.pagination.rowsPerPage - 1) {
            this.paginationApprobed.page++
          }
        } else {
          this.selectRow2(this.expensesApprobed[0])
          this.pagination.page = 1
        }
      }
    },
    resetCategories(){
      this.editCategory = false
      this.editCategoryF = false
      this.editCategoryAppF = false
      this.titleTagCategory = this.$t('general.category')
      this.editItemCategories = {}
    },
    viewNext(id) {
      this.resetCategories()
      let index = this.expensesItems.findIndex((x) => x.id === id)
      if (index <= this.expensesItems.length - 2) {
        if (this.expensesItems[index + 1].gst_receipt_types_id === 1) {
          this.viewItemsF(this.expensesItems[index + 1])
        } else {
          this.viewItems(this.expensesItems[index + 1])
        }
      } else {
        if (this.expensesItems[0].gst_receipt_types_id === 1) {
          this.viewItemsF(this.expensesItems[0])
        } else {
          this.viewItems(this.expensesItems[0])
        }
      }
    },
    viewPrevious(id) {
      this.resetCategories()
      let index = this.expensesItems.findIndex((x) => x.id === id)
      if (index !== 0) {
        if (this.expensesItems[index - 1].gst_receipt_types_id === 1) {
          this.viewItemsF(this.expensesItems[index - 1])
        } else {
          this.viewItems(this.expensesItems[index - 1])
        }
      } else {
        if (
          this.expensesItems[this.expensesItems.length - 1]
            .gst_receipt_types_id === 1
        ) {
          this.viewItemsF(this.expensesItems[this.expensesItems.length - 1])
        } else {
          this.viewItems(this.expensesItems[this.expensesItems.length - 1])
        }
      }
    },
    viewNextApp(id) {
      this.resetCategories()
      let index = this.expensesItemsApp.findIndex((x) => x.id === id)
      if (index <= this.expensesItemsApp.length - 2) {
        if (this.expensesItemsApp[index + 1].gst_receipt_types_id === 1) {
          this.viewItemsApprobedF(this.expensesItemsApp[index + 1])
        } else {
          this.viewItemsApprobed(this.expensesItemsApp[index + 1])
        }
      } else {
        if (this.expensesItemsApp[0].gst_receipt_types_id === 1) {
          this.viewItemsApprobedF(this.expensesItemsApp[0])
        } else {
          this.viewItemsApprobed(this.expensesItemsApp[0])
        }
      }
    },
    viewPreviousApp(id) {
      this.resetCategories()
      let index = this.expensesItemsApp.findIndex((x) => x.id === id)
      if (index !== 0) {
        if (this.expensesItemsApp[index - 1].gst_receipt_types_id === 1) {
          this.viewItemsApprobedF(this.expensesItemsApp[index - 1])
        } else {
          this.viewItemsApprobed(this.expensesItemsApp[index - 1])
        }
      } else {
        if (
          this.expensesItemsApp[this.expensesItemsApp.length - 1]
            .gst_receipt_types_id === 1
        ) {
          this.viewItemsApprobedF(
            this.expensesItemsApp[this.expensesItemsApp.length - 1]
          )
        } else {
          this.viewItemsApprobed(
            this.expensesItemsApp[this.expensesItemsApp.length - 1]
          )
        }
      }
    },
    dateFormat(date) {
      if (date) {
        let formatted = date.replace(/-/g, '/')
        return formatted
      }
    },
    getType(item) {
      if(item.is_imported_expense === 1) return 'travelExpense'
      if (item.petty_cash_type === 0 && item.is_blue_voucher) return 'voucher_blue' 
      if (item.petty_cash_type === 1) return 'petty_cash' 
      if (item.petty_cash_type === 2) return 'amexCard'
      if (parseFloat(item.advance) > 0) return 'advance'
      if (parseFloat(item.advance) <= 0 && item.petty_cash_type === 0) return 'refund'
      // if(item.is_blue_voucher === 1) return 'voucher_blue'
    },
    getTypeText(item) {
      switch (this.getType(item)) {
        case 'travelExpense': return this.$t('expenses.travelExpense.title') 
        case 'advance': return this.$t('general.advance')
        case 'refund': return this.$t('general.refund')
        case 'petty_cash': {
          const blueVoucherLabel = item.is_blue_voucher === 1 ? ` ${this.$t('general.with')} ${this.$t('general.okBlue')}` : '';
          return this.$t('pettyCash.pettyCash') + blueVoucherLabel;
        }
        case 'amexCard': {
          const blueVoucherLabel = item.is_blue_voucher === 1 ? ` ${this.$t('general.with')} ${this.$t('general.okBlue')}` : '';
          return this.$t('pettyCash.amexCard') + blueVoucherLabel;
        }
        case 'voucher_blue': return this.$t('general.okBlue')
        default: return ''
      }
    },
    filterCommentOptional(arr) {
      let arrayFilter = []
      if (arr && arr.length > 0) {
        arrayFilter = arr.filter((n) => n.comment !== null)
      }
      return arrayFilter
    },
    isRefund(repayBack) {
      let type = ''
      if (parseFloat(repayBack) >= 0) {
        type = 'payment'
      } else {
        type = 'refund'
      }
      return type
    },
    addTitleMultiProject (item) {
      const processed = {}
        item.gst_expenses_items.forEach(data => {
          data.has_multiprojects = true
          if(data.gst_receipt_types_id !== 4) data.projectName = item.multiprojects.find(x => x.id === data.project_id).name
          if (!processed[data.project_id]) {
            data.isTitle = true
            
            processed[data.project_id] = true
          } else {
            data.isTitle = false
          }
        })
    },
    selectRow(item = null) {
      if(item && item.has_multiprojects === 1) this.addTitleMultiProject(item)
      
      if (this.tab && this.tab === 'tab-1') {
        if (item !== null) {
          this.item = item
          this.expensesItems = item.gst_expenses_items.sort((a, b) => a.project_id - b.project_id)
          this.type = this.getType(item)
          this.typeText = this.getTypeText(item)
          this.advance = item.advance
          this.project = item.project.name
          this.startDate = item.start_date
          this.endDate = item.end_date
          this.expensesProgress = this.filterCommentOptional(
            item.expenses_progress
          )
          this.repay_back = item.repay_back
          this.suma_total_items = item.suma_total_items
          const prevItem = this.expenses.find((expense) => expense.isSelected)
          if (prevItem) {
            this.$set(prevItem, 'isSelected', false)
          }
          this.$set(item, 'isSelected', true)
        } else {
          
          let indexIdExpenseStorage = 0
          if (this.expenses.length > 0) {
            // const sortedExpenses = this.expenses.sort(
            //   (a, b) => new Date(b.date_sent) - new Date(a.date_sent)
            // )
            if (this.paginated && this.paginated.item && this.paginated.pagination) {
              // this.fromNoAuth = true;
              const pagingStorage = this.paginated;
              const storageItem= pagingStorage.item
              if (storageItem) {
                const expenseId = storageItem.id
                indexIdExpenseStorage = this.expenses.findIndex(object => object.id === expenseId);
              }
            }
            if (indexIdExpenseStorage > 0) {
              this.item = this.expenses[indexIdExpenseStorage]
            } else {
              // this.item = this.expenses[this.lastIndex]
              this.item = this.expenses[0]
            }
            this.type = this.getType(this.item)
            this.typeText = this.getTypeText(this.item)
            
            if(this.item && this.item.has_multiprojects === 1) this.addTitleMultiProject(this.item)

            this.expensesItems = this.item.gst_expenses_items.sort((a, b) => a.project_id - b.project_id)
            this.advance = this.item.advance
            this.project = this.item.project.name
            this.repay_back = this.item.repay_back
            this.startDate = this.item.start_date
            this.endDate = this.item.end_date
            this.expensesProgress = this.filterCommentOptional(
              this.item.expenses_progress
            )
            this.suma_total_items = this.item.suma_total_items
            const prevItem = this.expenses.find((expense) => expense.isSelected)
            if (prevItem) {
              this.$set(prevItem, 'isSelected', false)
            }
            this.$set(this.item, 'isSelected', true)
          } else {
            this.item = null
            this.expensesItems = []
            this.repay_back = 0
            this.isPettyCash = null
            this.advance = 0
            this.type = ''
            this.typeText = ''
            this.project = ''
          }
        }
  
        this.validateBtn = false
  
        this.calculateTotalTip(this.expensesItems)
  
        this.expensesItems.forEach((e, index) => {
          const payload = {
            ctx: this,
            index,
            id: e.id,
          }
          this.$store.dispatch('expensesItems/getTipByValidate', payload)
        })
        this.deleteLocalStorage()
      }
    },
    calculateTotalTip(expenses) {
      this.totalTip = 0
      this.totalGlobal = 0
      expenses.forEach((expense) => {
        if (expense.tip) this.totalTip += Number(expense.tip.amount)
        this.totalGlobal += (Number(expense.total) * Number(expense.exchange))
      })
    },
    addTitleMultiProjectAprober (item) {
      const processed = {}
        item.items.forEach(data => {
          data.has_multiprojects = true
          if(data.gst_receipt_types_id !== 4) data.projectName = item.multiprojects.find(x => x.id === data.project_id).name
          if (!processed[data.project_id]) {
            data.isTitle = true
            processed[data.project_id] = true
          } else {
            data.isTitle = false
          }
        })
    },
    selectRow2(item = null) {
      if(item && item.has_multiprojects === 1) this.addTitleMultiProjectAprober(item)
      
      if (this.tab && this.tab === 'tab-2') {
        
        if (item !== null) {
          this.item = item
          this.expensesItemsApp = item.items.sort((a, b) => a.project_id - b.project_id)
          this.expensesItemsApp.forEach(
              (obj) => 
                {
                  let file = this.item.gst_expenses_items.find(x => x.id === obj.id) 
                  obj.file_attach = file.file_attach; 
                  obj.item_lines = file.item_lines
                }
            );
          this.type = this.getType(item)
          this.typeText = this.getTypeText(item)
          this.advance = item.advance
          this.project = item.project.name ? item.project.name : ''
          this.startDate = item.start_date
          this.endDate = item.end_date
          this.expensesProgress = this.filterCommentOptional(
            item.expenses_progress
          )

          this.expensesItemsApp.forEach(
              (obj) => 
                {
                  let file = this.item.gst_expenses_items.find(x => x.id === obj.id) 
                  obj.item_lines = file.item_lines
                  obj.file_attach = file.file_attach 
                  obj.vendor = file.vendor
                }
            );

          this.repay_back = item.repay_back
          this.suma_total_items = item.suma_total_items
          this.suma_total_itemsApp = this.aTotal(item.items)
          const prevItem = this.expensesApprobed.find(
            (expense) => expense.isSelected
          )
          if (prevItem) {
            this.$set(prevItem, 'isSelected', false)
          }
          this.$set(item, 'isSelected', true)
        } else {
          let indexIdExpenseStorage = 0
          
          if (this.expensesApprobed.length > 0) {
            // const sortedExpenses = this.expensesApprobed.sort(
            //   (a, b) => new Date(b.date_sent) - new Date(a.date_sent)
            // )
            
            if (this.paginated && this.paginated.item && this.paginated.pagination) {
              const pagingStorage = this.paginated;
              const storageItem= pagingStorage.item
              if (storageItem) {
                const expenseId = storageItem.id
                indexIdExpenseStorage = this.expensesApprobed.findIndex(object => object.id === expenseId);
              }
            }
            
            if (indexIdExpenseStorage > 0) {
              this.item = this.expensesApprobed[indexIdExpenseStorage]
            } else {
              // this.item = this.expensesApprobed[this.lastIndex]
              this.item = this.expensesApprobed[0]
            }

            if(this.item && this.item.has_multiprojects === 1) this.addTitleMultiProjectAprober(this.item)

            this.type = this.getType(this.item)
            this.typeText = this.getTypeText(this.item)

            this.expensesItemsApp = this.item.items.sort((a, b) => a.project_id - b.project_id)

            this.expensesItemsApp.forEach(
              (obj) => 
                {
                  let file = this.item.gst_expenses_items.find(x => x.id === obj.id) 
                  obj.file_attach = file.file_attach
                  obj.item_lines = file.item_lines
                  obj.vendor = file.vendor
                }
            );
            
            this.isPettyCash = this.item.is_petty_cash
            this.advance = this.item.advance
            this.project = this.item.project.name ? this.item.project.name : ''
            this.repay_back = this.item.repay_back
            this.startDate = this.item.start_date
            this.endDate = this.item.end_date
            this.expensesProgress = this.filterCommentOptional(
              this.item.expenses_progress
            )
            this.suma_total_itemsApp = this.aTotal(this.item.items)
            const prevItem = this.expensesApprobed.find(
              (expense) => expense.isSelected
            )
            if (prevItem) {
              this.$set(prevItem, 'isSelected', false)
            }
            this.$set(this.item, 'isSelected', true)
          } else {
            this.item = null
            this.expensesItemsApp = []
            this.repay_back = 0
            this.isPettyCash = null
            this.advance = 0
            this.type = ''
            this.typeText = ''
            this.project = ''
          }
        }
 
        this.calculateTotalTip(this.expensesItemsApp)
        this.expensesItemsApp.forEach((e, index) => {
          const payload = {
            ctx: this,
            index,
            id: e.id,
          }
          this.$store.dispatch('expensesItems/getTipByAprobe', payload)
        })
        this.deleteLocalStorage()
      }
    },
    downloadXML(type) {
      this.loadingXML = true
      if (type === 'itemApproved') {
        this.$store.dispatch('downloadXML', {
          event: {
            context: this,
            fileId:
              this.editedItemApprobedF.gst_expenses_items_files[0].files_id,
            description: this.editedItemApprobedF.description,
          },
        })
      } else {
        this.$store.dispatch('downloadXML', {
          event: {
            context: this,
            fileId: this.editedItem.gst_expenses_items_files[0].files_id,
            description: this.editedItem.description,
          },
        })
      }
    },
    saveF(item) {
      if(item.gst_receipt_types_id === 1){
          if(this.conceptos.length > 0) item.item_lines = this.conceptos
          item.gst_categories_id = item.gst_category_id === undefined ? item.gst_categories_id : item.gst_category_id
          this.$emit('putConcepts', { item: item, context: this})
          return
        }
      if (this.$refs.formf.validate()) {
        this.loading = true
        this.disabled = true
        this.lastIndex = this.expenses.findIndex((x) => x.id === this.item.id)
        this.categoryPut(this.editedItem)
        if (this.expensesItems.length > 1) {
          // this.viewNext(this.editedItem.id)
        } else {
          this.close()
        }
      }
    },
    aTotal(items) {
      let total = 0
      if (items.length > 0) {
        items.map((item) => {
          total = total + parseFloat(item.total_mxn)
        })
        return total
      } else {
        return 0
      }
    },
    payback(item) {
      if (item > 0) {
        return this.$t('general.payment')
      } else if (item < 0) {
        return this.$t('general.refund')
      } else {
        return this.$t('general.noHave')
      }
    },
    isPDF(data) {
      if (data !== null) {
        let type = data.slice(data.indexOf('/') + 1, data.indexOf(';'))
        if (type === 'pdf') {
          return true
        } else {
          return false
        }
      }
    },
    openPDF() {
      var tab = window.open()
      tab.document.write(
        '<body style="margin: 0;"> <iframe src="' +
          this.dataURL +
          '" frameborder="0" style="margin: 0; padding: 0; border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;"</iframe></body>'
      )
    },
    changeSort(header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
      if (this.tab === 'tab-1') {
        //NO AFECTA EN NADA
        this.get()
      } else {
        this.getEApprobed()
      }
    },
    changeSortItems(header) {
      if (this.paginationItems.sortBy === header) {
        this.paginationItems.descending = !this.paginationItems.descending
      } else {
        this.paginationItems.descending = false
      }
      this.paginationItems.sortBy = header
    },
    getLogged() {
      if (this.$store.state.userLogged.company) {
        this.userloggeds = this.$store.state.userLogged
      }
    },
    checkPageChange() {
      if (this.initialPage) {
        this.initialPage = false;
      } else {
        this.valSearch = ''
        this.get();
      }
    },
    get() {
      if (this.pagingStorageGeneral && this.pagingStorageGeneral.pagination && this.pagingStorageGeneral.pagination.page !== this.pagination.page) {
        this.deleteLocalStorage()
      }
      this.loadingItems = true
      this.$emit('get', {
        user: this.userloggeds.validator,
        substitute: this.userloggeds.substitute,
        context: this,
        options: {
          perPage: this.pagination.rowsPerPage,
          page: this.pagination.page,
          sortKey: this.pagination.sortBy ? this.pagination.sortBy : 'id',
          ord: this.pagination.descending ? 'desc' : 'asc',
          find: this.valSearch,
        }
      })
    },
    checkPageChangeApp() {
      if (this.initialPageApp) {
        this.initialPageApp = false;
      } else {
        this.appSearch = ''
        this.getEApprobed();
      }
    },
    getEApprobed() {
      if (this.pagingStorageGeneral && this.pagingStorageGeneral.pagination && this.pagingStorageGeneral.pagination.page !== this.pagination.page) {
        this.deleteLocalStorage()
      }
      this.loadingItems = true
      this.tab = 'tab-2'
      this.$emit('getApprobed', {
        approbeds: this.userloggeds,
        context: this,
        options: {
          perPage: this.pagination.rowsPerPage,
          page: this.pagination.page,
          sortKey: this.pagination.sortBy ? this.pagination.sortBy : 'id',
          ord: this.pagination.descending ? 'desc' : 'asc',
          find: this.appSearch,
          isExpenseApprovalView: true, 
        }
      })
    },
    // login () {
    //   this.$emit('logged', {
    //     context: this
    //   })
    // },
    delete() {
      this.$emit('delete', {
        items: this.removedItem,
        context: this,
      })
    },
    deleteFV() {
      this.$emit('delete', {
        items: this.removedItemF,
        context: this,
      })
    },
    deleteA(item) {
      this.$emit('delete', {
        items: item,
        context: this,
      })
    },
    put() {
      const item = this.validat
      let index = this.expenses.findIndex(function (o) {
        return o.id === item.id
        })
      if (index !== -1) this.expenses.splice(index, 1)
      this.$emit('put', {
        expenses: this.validat,
        context: this,
      })
    },
    categoryPut(item) {
      this.$emit('categoryPut', {
        item: {
          id: item.id,
          gst_category_id:
            item.gst_categories_id === item.gst_category_id ||
            item.gst_category_id === undefined
              ? item.gst_categories_id
              : item.gst_category_id,
        },
        context: this,
      })
    },
    changeStatus() {
      this.$emit('changeStatus', {
        itemsV: this.approbed,
        context: this,
      })
    },
    refresh() {
      this.$emit('refresh', {
        user: this.userloggeds.validator,
        substitute: this.userloggeds.substitute,
        approbeds: this.userloggeds,
        context: this,
        options: {
          perPage: this.pagination.rowsPerPage,
          page: this.pagination.page,
          sortKey: this.pagination.sortBy ? this.pagination.sortBy : 'id',
          ord: this.pagination.descending ? 'desc' : 'asc',
          find: this.valSearch,
        }
      })
    },
    refreshValidateExpenses() {
      this.$emit('refreshValidateExpenses', {
        user: this.userloggeds.validator,
        substitute: this.userloggeds.substitute,
        approbeds: this.userloggeds,
        context: this,
      })
    },
    toggleAll(type) {
      let itemsTable = []
      switch (type) {
        case 'Validate':
          itemsTable = this.expensesItems
          break
        case 'Approve':
          itemsTable = this.expensesItemsApp
          break
      }
      if (this.selected.length) this.selected = []
      else this.selected = itemsTable.slice()
    },
    selectedExpenseItems() {
      this.multipleSelectedRejec = false
      if (this.selected.length > 0) {
        this.rejectedFromDialog = false
        let itemsId = this.selected.map((item) => {
          return item['id']
        })
        this.rejectedSelectedId = itemsId
        this.rejectedSelectedDialog = true
        this.loading = false
        this.disabled = false
      }
    },
    removed(editedItem, from) {
      this.multipleSelectedRejec = false
      this.rejectedFromDialog = from
      this.removedItem = editedItem
      this.removeDialog = true
      this.loading = false
      this.disabled = false
    },
    removedF(editedItem, from) {
      this.multipleSelectedRejec = false
      this.rejectedFromDialog = from
      this.removedItemF = editedItem
      this.removeDialogF = true
      this.loading = false
      this.disabled = false
    },
    removedApprobedF(editedItemApprobedF, from) {
      this.multipleSelectedRejec = false
      this.rejectedFromDialog = from
      this.general = editedItemApprobedF
      this.removeDialogApprobed = true
      this.loading = false
      this.disabled = false
    },
    removedApprobed(itemsApprobedView, from) {
      this.multipleSelectedRejec = false
      this.rejectedFromDialog = from
      this.general = itemsApprobedView
      this.removeDialogApprobed = true
      this.loading = false
      this.disabled = false
    },
    submitMultipleRejectedItems() {
      if (this.$refs.formR.validate()) {
        this.removedItem.validator_comment = this.editedItem.validator_comment
        this.multipleSelectedRejec = true
        this.delete()
        this.loading = true
        this.disabled = true
      }
      this.rejectedFromDialog = false
    },
    deleteItem(item) {
      if (this.$refs.formR.validate()) {
        this.lastIndex = this.expenses.findIndex((x) => x.id === this.item.id)
        this.removedItem.validator_comment = this.editedItem.validator_comment
        this.delete()
        this.loading = true
        this.disabled = true
        if (this.rejectedFromDialog) {
          if (this.expensesItems.length > 1) {
            this.viewNext(item.id)
          } else {
            this.close()
          }
        }
      }
      this.rejectedFromDialog = false
      this.savePagingStorage(this.item)
    },
    deteleItemValidateF(itemsF) {
      if (this.$refs.formDVF.validate()) {
        this.lastIndex = this.expenses.findIndex((x) => x.id === this.item.id)
        this.deleteFV()
        this.loading = true
        this.disabled = true
        if (this.rejectedFromDialog) {
          if (this.expensesItems.length > 1) {
            this.viewNext(itemsF.id)
          } else {
            this.close()
          }
        }
      }
      this.rejectedFromDialog = false
    },
    deteleItemApprobed(general) {
      if (this.$refs.formF.validate()) {
        // this.deleteAF()
        this.lastIndexApp = this.expensesApprobed.findIndex(
          (x) => x.id === this.item.id
        )
        this.deleteA(general)
        this.loading = true
        this.disabled = true
        if (this.rejectedFromDialog) {
          if (this.expensesItemsApp.length > 1) {
            this.viewNextApp(general.id)
          } else {
            this.close()
          }
        }
      }
      this.rejectedFromDialog = false
    },
    viewItemsF(items) {
      const taxID = this.$store.state.userLogged.company[0].tax_id
      if (
        taxID === 'ING1811295P0' &&
        items.sat_formaPago_id !== null &&
        items.uuid === null
      ) {
        if (!items.gst_receipt_types) {
          items.gst_receipt_types = {
            name: 'fiscal',
          }
        }
        this.viewItemsApprobed(items)
        return
      }

      // this.dialogApprobedF = true
      this.dataURL = null
      this.cfdiHtml = null
      this.editedItemTip = this.defaultItemTip
      this.receipt_type = 1
      // let index = this.expensesItems.findIndex(x => x.id === items.id)
      // if (index !== 0) {
      //   this.showPrevious = true
      // } else {
      //   this.showPrevious = false
      // }
      // if (index !== this.expensesItems.length - 1) {
      //   this.showNext = true
      // } else {
      //   this.showNext = false
      // }
      this.addTip(items)
      if (items.gst_expenses_items_files.length > 0) {
        this.editedItem = items
        this.$emit('readXmlToHtml', {
          id: items.gst_expenses_items_files[0].files_id,
          context: this,
          type: 'viewItemsF',
        })
      }
      items.views = true
    },
    closeNewItemsApprobed() {
      this.dialogNewApprobed = false
    },
    closeNewItems() {
      this.dialogNew = false
      this.itemsNew = {
        user: {},
      }
    },
    viewItems(items) {
      this.dataURL = null
      this.cfdiHtml = null
      this.editedItemTip = this.defaultItemTip
      this.receipt_type = 2
      this.addTip(items)
      this.editedItem = Object.assign({}, items)
      this.editedItem.gst_category_id = this.editedItem.gst_categories
        ? this.editedItem.gst_categories.id
        : null
      this.dialogF = true
      this.loading = false
      this.disabled = false
      items.views = true
      if (items.gst_receipt_types_id === 2 || items.gst_receipt_types_id === 3) {
        if (
          items.gst_expenses_items_files !== undefined &&
          items.gst_expenses_items_files !== null
        ) {
          if (items.gst_expenses_items_files.length > 0) {
            this.$store.dispatch('getFile', {
              event: {
                context: this,
                fileId: items.gst_expenses_items_files[0].files_id,
              },
            })
          }
        }
      }
    },
    viewItemsApprobed(itemsApprobed) {
      this.dataURL = null
      this.cfdiHtml = null
      this.editedItemTip = this.defaultItemTip
      this.receipt_type = 2
      this.addTip(itemsApprobed)
      this.itemsApprobedView = Object.assign({}, itemsApprobed)
      this.dialogApprobedF = true
      this.loading = false
      this.disabled = false
      itemsApprobed.views = true
      const taxID = this.$store.state.userLogged.company[0].tax_id

      if (itemsApprobed.gst_receipt_types_id === 2 || itemsApprobed.gst_receipt_types_id === 3) {
        if (
          itemsApprobed.gst_expenses_items_files !== undefined &&
          itemsApprobed.gst_expenses_items_files !== null
        ) {
          if (itemsApprobed.gst_expenses_items_files.length > 0) {
            this.$store.dispatch('getFile', {
              event: {
                context: this,
                fileId: itemsApprobed.gst_expenses_items_files[0].files_id,
              },
            })
          }
        }
        //Agregar condicion para la empresa Ingraphos, mostrar archivos para gastos no fiscales de las categorias Caseta y Gasolina
      } else if(taxID === 'ING1811295P0' && 
              itemsApprobed.gst_receipt_types_id === 1 && 
              itemsApprobed.gst_categories.name === 'Caseta' || 
              itemsApprobed.gst_categories.name ===  'Gasolina') {
          if (
            itemsApprobed.gst_expenses_items_files !== undefined &&
            itemsApprobed.gst_expenses_items_files !== null
          ) {
            if (itemsApprobed.gst_expenses_items_files.length > 0) {
              this.$store.dispatch('getFile', {
                event: {
                  context: this,
                  fileId: itemsApprobed.gst_expenses_items_files[0].files_id,
                },
              })
            }
          }
      }
    },
    viewItemsApprobedF(itemsF) {
      const taxID = this.$store.state.userLogged.company[0].tax_id
      if (
        taxID === 'ING1811295P0' &&
        itemsF.sat_formaPago_id !== null &&
        itemsF.uuid === null
      ) {
        itemsF.isFiscal = true
        this.viewItemsApprobed(itemsF)
        return
      }

      this.dataURL = null
      this.cfdiHtml = null
      this.editedItemTip = this.defaultItemTip
      this.receipt_type = 1
      this.addTip(itemsF)
      if (itemsF.gst_expenses_items_files.length > 0) {
        this.editedItemApprobedF = itemsF
        this.$emit('readXmlToHtml', {
          id: itemsF.gst_expenses_items_files[0].files_id,
          context: this,
          type: 'viewItemsApprobedF',
        })
        itemsF.views = true
      }
    },
    confirmValidate(item) {
      this.validat = Object.assign({}, item)
      this.validateBtn = true
      this.dialogValidate = true
      this.loading = false
      this.disabled = false
    },
    validates(item) {
      if (this.expenses.length >= 2) {
        this.nextExpense(item)
      } else {
        this.expensesItems = []
        this.expenses = []
        this.advance = null
        this.startDate = null
        this.endDate = null
        this.refund = null
        this.payment = null
        this.repay_back = null
        this.suma_total_items = 0
      }
      this.loading = true
      this.disabled = true
      this.put()
    },
    confirmApprobed(itemA) {
      this.approbed = Object.assign({}, itemA)
      this.dialogApprobed = true
      this.loading = false
      this.disabled = false
    },
    approb(approbed) {
      if (this.expensesApprobed.length >= 2) {
        this.nextExpense2(approbed)
      } else {
        this.expensesItemsApp = []
        this.expensesApprobed = []
        this.advance = null
        this.startDate = null
        this.endDate = null
        this.refund = null
        this.payment = null
        this.repay_back = null
        this.suma_total_items = 0
      }
      this.changeStatus()
      this.loading = true
      this.disabled = true
    },
    saveConfirm() {
      this.loading = false
      this.loadingExpensesItems = false
      this.disabled = false
      // this.dialog = false
      this.dialogValidate = false
      this.dialogApprobedView = false
      this.dialogApprobed = false
      // this.dialogF = false
      // this.dataURL = null
      // this.cfdiHtml = null
      // this.editedItemTip = this.defaultItemTip
      // this.dialogApprobedF = false
      // this.editedItem = this.defaultItem
      // this.editedItemApprobedF = this.defaultItem
      // // this.itemsApprobedView = this.defaultItemA
      // if (this.$refs.approvedFiscalForm) this.$refs.approvedFiscalForm.resetValidation()
      // if (this.$refs.approvedNoFiscalForm) this.$refs.approvedNoFiscalForm.resetValidation()
    },
    close() {
      this.loading = false
      this.concepts = []
      this.loadingExpensesItems = false
      this.disabled = false
      this.dialog = false
      this.dialogValidate = false
      this.dialogApprobedView = false
      this.dialogApprobed = false
      this.dialogF = false
      this.dataURL = null
      this.cfdiHtml = null
      this.editedItemTip = this.defaultItemTip
      this.dialogApprobedF = false
      this.editedItem = this.defaultItem
      this.editedItemApprobedF = this.defaultItem
      this.itemsApprobedView = this.defaultItemA
      this.validatorCommentDialog = false
      this.multipleSelectedRejec = false
      this.rejectedSelectedId = []
      this.validateBtn = false
      this.backCheckoutDialog = false
      this.itemCommentBackCheckout = ''
      this.dialogEditExpenseItem = false
      this.editedItemExpense = Object.assign({}, this.defaultItemExpense)
      this.resetCategories()
      if (this.$refs.approvedFiscalForm)
        this.$refs.approvedFiscalForm.resetValidation()
      if (this.$refs.approvedNoFiscalForm)
        this.$refs.approvedNoFiscalForm.resetValidation()
      if (this.$refs.backCheckoutDialogForm)
        this.$refs.backCheckoutDialogForm.resetValidation()
        if (this.$refs.backCheckoutDialogForm)
        this.$refs.dialogEditExpenseItemForm.resetValidation()
    },
    closeDeleteApprobed() {
      this.general.validator_comment = ''
      this.removeDialogApprobed = false
      this.rejectedSelectedDialog = false
      this.multipleSelectedRejec = false
      this.loading = false
      this.disabled = false
    },
    closeDelete() {
      this.editedItem.validator_comment = ''
      this.removeDialog = false
      this.rejectedSelectedDialog = false
      this.multipleSelectedRejec = false
      this.loading = false
      this.disabled = false
    },
    closeDeleteValidateF() {
      this.editedItem.validator_comment = ''
      this.removeDialogF = false
      // this.dialogF = false
      this.loading = false
      this.disabled = false
    },
    confirmRejected() {
      // this.dialog = false
      this.removeDialog = false
      this.removeDialogApprobed = false
      this.rejectedSelectedDialog = false
      this.multipleSelectedRejec = false
      this.selected = []
      // this.dialogApprobedView = false
      this.loading = false
      this.disabled = false
      this.dataURL = null
    },
    confirmA() {
      this.dialogValidate = false
      this.dialogNew = false
      this.loading = false
      this.disabled = false
    },
    confirm() {
      this.dialogApprobed = false
      this.dialogNewApprobed = false
      this.loading = false
      this.disabled = false
    },
    removeExpenseItemFromItemsNew(expenseItemId) {
      if (this.itemsNew !== undefined && expenseItemId !== null) {
        if (this.itemsNew.gst_expenses_items !== undefined) {
          if (this.itemsNew.gst_expenses_items.length > 0) {
            let expenseItemFound = this.itemsNew.gst_expenses_items.findIndex(
              function (element) {
                return element.id === expenseItemId
              }
            )
            this.itemsNew.gst_expenses_items.splice(expenseItemFound)
          }
        }
      }
    },
    save(item) {
      if(item.gst_receipt_types_id === 3){
          if(this.concepts.length > 0) item.item_lines = this.concepts
          item.gst_categories_id = item.gst_category_id === undefined ? item.gst_categories_id : item.gst_category_id
          this.$emit('putConcepts', { item: item, context: this})
          return
        }

      if (this.$refs.form.validate()) {
        this.loading = true
        this.disabled = true
        this.lastIndex = this.expenses.findIndex((x) => x.id === this.item.id)
        this.categoryPut(this.editedItem)

        if (this.expensesItems.length > 1) {
          // this.viewNext(this.editedItem.id)
        } else {
          this.close()
        }
      }
    },
    saveApprob(item) {
      if(item.gst_receipt_types_id === 3){
          if(this.concepts.length > 0) item.item_lines = this.concepts
          item.gst_categories_id = item.gst_category_id === undefined ? item.gst_categories_id : item.gst_category_id
          this.$emit('putConcepts', { item: item, context: this})
          return
        }

      if (this.$refs.approvedNoFiscalForm.validate()) {
        this.loading = true
        this.lastIndexApp = this.expensesApprobed.findIndex(
          (x) => x.id === this.item.id
        )
        this.categoryPut(this.itemsApprobedView)
        if (this.expensesItemsApp.length > 1) {
          // this.viewNextApp(this.itemsApprobedView.id)
        } else {
          this.close()
        }
      }
    },
    saveApprobF(item) {
      if(item.gst_receipt_types_id === 1){
          if(this.conceptos.length > 0) item.item_lines = this.conceptos
          item.gst_categories_id = item.gst_category_id === undefined ? item.gst_categories_id : item.gst_category_id
          this.$emit('putConcepts', { item: item, context: this})
          return
        }
      if (this.$refs.approvedFiscalForm.validate()) {
        this.loading = true
        this.lastIndexApp = this.expensesApprobed.findIndex(
          (x) => x.id === this.item.id
        )
        this.categoryPut(this.editedItemApprobedF)
        if (this.expensesItemsApp.length > 1) {
          // this.viewNextApp(this.itemsApprobedView.id)
        } else {
          this.close()
        }
      }
    },
    expensesApprobedTotal() {
      this.sumaTotalApprobed = 0
      this.expensesApprobed.forEach((element) => {
        element.items.forEach((elements) => {
          this.sumaTotalApprobed += parseFloat(elements.total_mxn)
        })
      })
    },
    expensesTotal() {
      this.sumaTotal = 0
      this.expenses.forEach((element) => {
        this.sumaTotal += element.suma_total_items
      })
    },
    currencyFormat(val) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      })
      return formatter.format(val)
    },
    savePagingStorage(item = null) {
      if (item && this.pagination) {
        // const data = {
        //   item: this.item,
        //   pagination: this.pagination
        // }
        // localStorage.setItem('pagingStorage', JSON.stringify(data))
        this.$store.commit("setPaginated", {
          item: this.item,
          pagination: this.pagination,
        });
      }
    },
    addTip(item) {
      this.editedItemTip.id = item.id
      this.getTip(item)
    },
    getTip(item) {
      this.$emit('getTip', {
        context: this,
        id: item.id,
      })
    },
    getFile(fileId) {
      this.$store.dispatch('getFile', {
        event: {
          context: this,
          fileId: fileId,
        },
      })
    },
    closeDialogTip() {
      this.dialogTip = false
      this.editedItemTip = Object.assign(
        {},
        JSON.parse(JSON.stringify(this.defaultItemTip))
      )
      this.editedIndexTip = -1
      this.reset()
    },
    reset() {
      this.$refs.form.resetValidation()
      if (this.$refs.dropzone !== undefined) {
        this.$refs.dropzone.removeAllFiles()
      }
      this.dataURL = null
    },
    fileAdded(file) {
      this.dropzoneOptions.params.user_id = this.$store.state.userLogged.id
      let fileType = file.type
      if (fileType === 'image/jpeg') {
        this.dropzoneOptions.params.files_type_id = 5
      } else if (fileType === 'image/png') {
        this.dropzoneOptions.params.files_type_id = 6
      } else if (fileType === 'application/pdf') {
        this.dropzoneOptions.params.files_type_id = 3
      }
    },
    fileUpload(file, response) {
      this.editedItem.fileId = response.data.id
    },
    fileUploadTip(file, response) {
      this.editedItemTip.fileId = response.data.id
    },
    fileUploadError(file, message, xh) {
      this.showNotification(message, 'error', -1)
      this.errorMessage = message.errors.path[0]
      //   this.$refs.dropzoneXML = message.errors.path[0]
    },
    submitTip() {
      if (this.$refs.tipForm.validate()) {
        this.loading = true
        if (
          this.editedItemTip.fileId !== null &&
          this.editedItemTip.fileId !== undefined
        ) {
          this.postTip()
        } else {
          this.loading = false
          this.showNotification(
            this.$t('expenseItems.noFileUploaded'),
            'error',
            -1
          )
        }
      }
    },
    postTip() {
      this.$emit('postTip', {
        item: this.editedItemTip,
        context: this,
      })
    },
    openValidatorComment() {
      this.validatorCommentDialog = true
    },
    travelExpenseRequestDownload(type, item) {
      const newType = type
      const newItem = {
        id: item.gst_travel_expenses_request_id,
        folio: item.date_sent
      }
      this.loadingDownload = true
      this.$emit('downloadTravelExpeseRequest', {
        context: this,
        item: newItem,
        type: newType,
      })
    },
    openBackCheckoutDialog (item) {
      this.itemBackCheckoutDialog.expenseId = item.id ? item.id : '--'
      this.itemBackCheckoutDialog.userName = item.user && item.user.name ? item.user.name : '--'
      this.backCheckoutDialog = true
    },
    submitBackCheckout () {
      if (!this.$refs.backCheckoutDialogForm.validate()) return
      const params = {
        id: this.item.id,
        comment: this.itemCommentBackCheckout
      }
      this.loading = true
      this.$emit('backCheckoutPut', {
        item: params,
        context: this,
      })
    },
    editExpenseItem (val) {
      const item = val
      this.editedItemExpense = Object.assign({}, item)
      this.editedItemExpense.viatic_request_id =
        item.gst_travel_expenses_request_id !== null
          ? item.gst_travel_expenses_request_id
          : null
      if (item.gst_travel_expenses_request_id !== null) {
        this.editedItemExpense.has_request = true
      } else {
        this.editedItemExpense.has_request = false
      }
      this.dialogEditExpenseItem = true
    },
    expenseUpdate () {
      if (this.$refs.dialogEditExpenseItemForm.validate()) {
        this.loading = true
        this.$emit('putExpense', {
          item: this.editedItemExpense,
          index: this.editedIndex,
          context: this
        })
        this.$store.commit("setPaginated", {
          item: this.item,
          pagination: this.pagination,
        });
      }
    },
    deleteLocalStorage () {
      // if (localStorage.getItem('pagingStorage')) {
      //   localStorage.removeItem('pagingStorage');
      // }
      this.$store.commit("setPaginated", {
          item: null,
          pagination: null,
        });
    },
    searching () {
      this.pagination.page = 1
      this.pagination.perPage = 5
      if (this.tab === 'tab-1') {
        this.get()
      } else {
        this.getEApprobed()
      }
    },
  },
}
</script>

<style lang="css" scoped>
  ::v-deep  .v-data-footer {
    padding: 0 100px;
  }
  .grey-row {
    background-color: #f5f5f5; /* Color gris claro */
  }
  .white-row {
    background-color: #ffffff; /* Color blanco */
  }
  .totals-row {
      height: 15px; /* Ajusta esta altura según tus necesidades */
      padding: 0;
  }
  .totals-row td {
    padding: 0 5px;
    font-size: 12px; /* Ajusta el tamaño de la fuente si es necesario */
    line-height: 15px; /* Asegura que el texto esté centrado verticalmente */
  }
  .totals-row .v-btn {
    min-width: 15px;
    height: 15px;
    width: 15px;
  }
.dynamic-textarea {
  max-height: 4em; /* Altura máxima deseada (3 líneas) */
  overflow-y: auto; /* Agregar barra de desplazamiento vertical cuando se exceda la altura máxima */
  /*border-bottom: 1px solid #000; */ /* Agrega linea abajo para que se vea bien el input */
}
.red-text {
  color: #b71c1c ;
}
.th,
th {
  padding: 0 0px !important;
}
.selectedRow {
  background-color: #a4a4a4 !important;
}
.rowExpense {
  cursor: pointer;
}
.type-color {
  color: #e24036 !important;
}
.advance-color {
  color: #407ee9 !important;
}
.petty-cash-color {
  color: orange !important;
}
.payment-color {
  color: #5f9b35 !important;
}

.tab:hover {
  color: #ffffff !important;
  text-decoration: none !important;
}
.h3-period {
  margin-bottom: 0px !important;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.0); /* Color de fondo transparente */
}
.marginLeft{
  margin-left: 70px;
}

.warning-row {
  background-color: #ffcc6670;
}

.warning-rows {
  background-color: #ffcc6670;
}
.custom-row-color {
    background-color:rgba(137, 119, 240, 0.322); /* Cambia el color a tu preferencia */
}
</style>



// WEBPACK FOOTER //
// src/components/expensesValidate.component.vue